/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ var $f5ed4ab2a4d1861b$var$extendStatics = function(d, b) {
    $f5ed4ab2a4d1861b$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $f5ed4ab2a4d1861b$var$extendStatics(d, b);
};
function $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $f5ed4ab2a4d1861b$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $f5ed4ab2a4d1861b$export$18ce0697a983be9b = function() {
    $f5ed4ab2a4d1861b$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $f5ed4ab2a4d1861b$export$18ce0697a983be9b.apply(this, arguments);
};
function $f5ed4ab2a4d1861b$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $f5ed4ab2a4d1861b$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $f5ed4ab2a4d1861b$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $f5ed4ab2a4d1861b$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $f5ed4ab2a4d1861b$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $f5ed4ab2a4d1861b$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $f5ed4ab2a4d1861b$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $f5ed4ab2a4d1861b$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $f5ed4ab2a4d1861b$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $f5ed4ab2a4d1861b$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $f5ed4ab2a4d1861b$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $f5ed4ab2a4d1861b$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(o, m, p);
}
function $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $f5ed4ab2a4d1861b$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $f5ed4ab2a4d1861b$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($f5ed4ab2a4d1861b$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $f5ed4ab2a4d1861b$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $f5ed4ab2a4d1861b$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v) {
    return this instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? (this.v = v, this) : new $f5ed4ab2a4d1861b$export$10c90e4f7922046c(v);
}
function $f5ed4ab2a4d1861b$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $f5ed4ab2a4d1861b$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $f5ed4ab2a4d1861b$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $f5ed4ab2a4d1861b$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $f5ed4ab2a4d1861b$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $f5ed4ab2a4d1861b$export$19a8beecd37a4c45 === "function" ? $f5ed4ab2a4d1861b$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $f5ed4ab2a4d1861b$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $f5ed4ab2a4d1861b$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $f5ed4ab2a4d1861b$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $f5ed4ab2a4d1861b$export$45d3717a4c69092e(result, mod, k);
    }
    $f5ed4ab2a4d1861b$var$__setModuleDefault(result, mod);
    return result;
}
function $f5ed4ab2a4d1861b$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $f5ed4ab2a4d1861b$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $f5ed4ab2a4d1861b$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $f5ed4ab2a4d1861b$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $f5ed4ab2a4d1861b$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $f5ed4ab2a4d1861b$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $f5ed4ab2a4d1861b$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $f5ed4ab2a4d1861b$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $f5ed4ab2a4d1861b$export$2e2bcd8739ae039 = {
    __extends: $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a,
    __assign: $f5ed4ab2a4d1861b$export$18ce0697a983be9b,
    __rest: $f5ed4ab2a4d1861b$export$3c9a16f847548506,
    __decorate: $f5ed4ab2a4d1861b$export$29e00dfd3077644b,
    __param: $f5ed4ab2a4d1861b$export$d5ad3fd78186038f,
    __metadata: $f5ed4ab2a4d1861b$export$f1db080c865becb9,
    __awaiter: $f5ed4ab2a4d1861b$export$1050f835b63b671e,
    __generator: $f5ed4ab2a4d1861b$export$67ebef60e6f28a6,
    __createBinding: $f5ed4ab2a4d1861b$export$45d3717a4c69092e,
    __exportStar: $f5ed4ab2a4d1861b$export$f33643c0debef087,
    __values: $f5ed4ab2a4d1861b$export$19a8beecd37a4c45,
    __read: $f5ed4ab2a4d1861b$export$8d051b38c9118094,
    __spread: $f5ed4ab2a4d1861b$export$afc72e2116322959,
    __spreadArrays: $f5ed4ab2a4d1861b$export$6388937ca91ccae8,
    __spreadArray: $f5ed4ab2a4d1861b$export$1216008129fb82ed,
    __await: $f5ed4ab2a4d1861b$export$10c90e4f7922046c,
    __asyncGenerator: $f5ed4ab2a4d1861b$export$e427f37a30a4de9b,
    __asyncDelegator: $f5ed4ab2a4d1861b$export$bbd80228419bb833,
    __asyncValues: $f5ed4ab2a4d1861b$export$e3b29a3d6162315f,
    __makeTemplateObject: $f5ed4ab2a4d1861b$export$4fb47efe1390b86f,
    __importStar: $f5ed4ab2a4d1861b$export$c21735bcef00d192,
    __importDefault: $f5ed4ab2a4d1861b$export$da59b14a69baef04,
    __classPrivateFieldGet: $f5ed4ab2a4d1861b$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $f5ed4ab2a4d1861b$export$d40a35129aaff81f,
    __classPrivateFieldIn: $f5ed4ab2a4d1861b$export$81fdc39f203e4e04,
    __addDisposableResource: $f5ed4ab2a4d1861b$export$88ac25d8e944e405,
    __disposeResources: $f5ed4ab2a4d1861b$export$8f076105dc360e92
};





function $390adda5fd19a2d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}


function $18bb82b1635a7e79$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $026eda5c570ccb60$export$c9648b76fd580c34 = (0, $18bb82b1635a7e79$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $fb0c758b8faa1e2a$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $0c79c60f10e25061$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $f5ed4ab2a4d1861b$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $026eda5c570ccb60$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $f5ed4ab2a4d1861b$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $0c79c60f10e25061$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $026eda5c570ccb60$export$c9648b76fd580c34)) errors = (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)((0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(errors)), (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $026eda5c570ccb60$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $0c79c60f10e25061$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $fb0c758b8faa1e2a$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $fb0c758b8faa1e2a$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $0c79c60f10e25061$export$610f9c3ca1a38dd8 = $0c79c60f10e25061$export$f55210826850c514.EMPTY;
function $0c79c60f10e25061$export$4f9221cbada3c4fc(value) {
    return value instanceof $0c79c60f10e25061$export$f55210826850c514 || value && "closed" in value && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.remove) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.add) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $0c79c60f10e25061$var$execFinalizer(finalizer) {
    if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $6c9b71106df82c02$export$e19cd5f9376f8cee = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(Action, _super);
    function Action(scheduler, work) {
        return _super.call(this) || this;
    }
    Action.prototype.schedule = function(state, delay) {
        if (delay === void 0) delay = 0;
        return this;
    };
    return Action;
}((0, $0c79c60f10e25061$export$f55210826850c514));



var $a03c46c28b149d0f$export$f0ca5e16f6f68711 = {
    setInterval: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $a03c46c28b149d0f$export$f0ca5e16f6f68711.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setInterval) return delegate.setInterval.apply(delegate, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
        return setInterval.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
    },
    clearInterval: function(handle) {
        var delegate = $a03c46c28b149d0f$export$f0ca5e16f6f68711.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearInterval) || clearInterval)(handle);
    },
    delegate: undefined
};



var $2552988672225634$export$b5369ffd7cb2211b = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AsyncAction, _super);
    function AsyncAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        _this.pending = false;
        return _this;
    }
    AsyncAction.prototype.schedule = function(state, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (this.closed) return this;
        this.state = state;
        var id = this.id;
        var scheduler = this.scheduler;
        if (id != null) this.id = this.recycleAsyncId(scheduler, id, delay);
        this.pending = true;
        this.delay = delay;
        this.id = (_a = this.id) !== null && _a !== void 0 ? _a : this.requestAsyncId(scheduler, this.id, delay);
        return this;
    };
    AsyncAction.prototype.requestAsyncId = function(scheduler, _id, delay) {
        if (delay === void 0) delay = 0;
        return (0, $a03c46c28b149d0f$export$f0ca5e16f6f68711).setInterval(scheduler.flush.bind(scheduler, this), delay);
    };
    AsyncAction.prototype.recycleAsyncId = function(_scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay != null && this.delay === delay && this.pending === false) return id;
        if (id != null) (0, $a03c46c28b149d0f$export$f0ca5e16f6f68711).clearInterval(id);
        return undefined;
    };
    AsyncAction.prototype.execute = function(state, delay) {
        if (this.closed) return new Error("executing a cancelled action");
        this.pending = false;
        var error = this._execute(state, delay);
        if (error) return error;
        else if (this.pending === false && this.id != null) this.id = this.recycleAsyncId(this.scheduler, this.id, null);
    };
    AsyncAction.prototype._execute = function(state, _delay) {
        var errored = false;
        var errorValue;
        try {
            this.work(state);
        } catch (e) {
            errored = true;
            errorValue = e ? e : new Error("Scheduled action threw falsy error");
        }
        if (errored) {
            this.unsubscribe();
            return errorValue;
        }
    };
    AsyncAction.prototype.unsubscribe = function() {
        if (!this.closed) {
            var _a = this, id = _a.id, scheduler = _a.scheduler;
            var actions = scheduler.actions;
            this.work = this.state = this.scheduler = null;
            this.pending = false;
            (0, $fb0c758b8faa1e2a$export$dae3f38077fc36c0)(actions, this);
            if (id != null) this.id = this.recycleAsyncId(scheduler, id, null);
            this.delay = null;
            _super.prototype.unsubscribe.call(this);
        }
    };
    return AsyncAction;
}((0, $6c9b71106df82c02$export$e19cd5f9376f8cee));




var $5bd7469f2b0fbe5b$export$a01aa5c744e19a32 = {
    schedule: function(callback) {
        var request = requestAnimationFrame;
        var cancel = cancelAnimationFrame;
        var delegate = $5bd7469f2b0fbe5b$export$a01aa5c744e19a32.delegate;
        if (delegate) {
            request = delegate.requestAnimationFrame;
            cancel = delegate.cancelAnimationFrame;
        }
        var handle = request(function(timestamp) {
            cancel = undefined;
            callback(timestamp);
        });
        return new (0, $0c79c60f10e25061$export$f55210826850c514)(function() {
            return cancel === null || cancel === void 0 ? void 0 : cancel(handle);
        });
    },
    requestAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = $5bd7469f2b0fbe5b$export$a01aa5c744e19a32.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.requestAnimationFrame) || requestAnimationFrame).apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
    },
    cancelAnimationFrame: function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var delegate = $5bd7469f2b0fbe5b$export$a01aa5c744e19a32.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.cancelAnimationFrame) || cancelAnimationFrame).apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
    },
    delegate: undefined
};


var $6304afbe8e115d4c$export$20b61f85ef6e6915 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AnimationFrameAction, _super);
    function AnimationFrameAction(scheduler, work) {
        var _this = _super.call(this, scheduler, work) || this;
        _this.scheduler = scheduler;
        _this.work = work;
        return _this;
    }
    AnimationFrameAction.prototype.requestAsyncId = function(scheduler, id, delay) {
        if (delay === void 0) delay = 0;
        if (delay !== null && delay > 0) return _super.prototype.requestAsyncId.call(this, scheduler, id, delay);
        scheduler.actions.push(this);
        return scheduler._scheduled || (scheduler._scheduled = (0, $5bd7469f2b0fbe5b$export$a01aa5c744e19a32).requestAnimationFrame(function() {
            return scheduler.flush(undefined);
        }));
    };
    AnimationFrameAction.prototype.recycleAsyncId = function(scheduler, id, delay) {
        var _a;
        if (delay === void 0) delay = 0;
        if (delay != null ? delay > 0 : this.delay > 0) return _super.prototype.recycleAsyncId.call(this, scheduler, id, delay);
        var actions = scheduler.actions;
        if (id != null && ((_a = actions[actions.length - 1]) === null || _a === void 0 ? void 0 : _a.id) !== id) {
            (0, $5bd7469f2b0fbe5b$export$a01aa5c744e19a32).cancelAnimationFrame(id);
            scheduler._scheduled = undefined;
        }
        return undefined;
    };
    return AnimationFrameAction;
}((0, $2552988672225634$export$b5369ffd7cb2211b));




var $61cacee395c43eea$export$c1895ea2d519a677 = {
    now: function() {
        return ($61cacee395c43eea$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $afeba06f7c4a1139$export$d3e54bb8584cda7c = function() {
    function Scheduler(schedulerActionCtor, now) {
        if (now === void 0) now = Scheduler.now;
        this.schedulerActionCtor = schedulerActionCtor;
        this.now = now;
    }
    Scheduler.prototype.schedule = function(work, delay, state) {
        if (delay === void 0) delay = 0;
        return new this.schedulerActionCtor(this, work).schedule(state, delay);
    };
    Scheduler.now = (0, $61cacee395c43eea$export$c1895ea2d519a677).now;
    return Scheduler;
}();


var $ef016f6d4d466007$export$4114a3ec92faa3c6 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AsyncScheduler, _super);
    function AsyncScheduler(SchedulerAction, now) {
        if (now === void 0) now = (0, $afeba06f7c4a1139$export$d3e54bb8584cda7c).now;
        var _this = _super.call(this, SchedulerAction, now) || this;
        _this.actions = [];
        _this._active = false;
        return _this;
    }
    AsyncScheduler.prototype.flush = function(action) {
        var actions = this.actions;
        if (this._active) {
            actions.push(action);
            return;
        }
        var error;
        this._active = true;
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while (action = actions.shift());
        this._active = false;
        if (error) {
            while(action = actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AsyncScheduler;
}((0, $afeba06f7c4a1139$export$d3e54bb8584cda7c));


var $a9319362b2c6ac5f$export$5ac76215a6c70aaa = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AnimationFrameScheduler, _super);
    function AnimationFrameScheduler() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AnimationFrameScheduler.prototype.flush = function(action) {
        this._active = true;
        var flushId = this._scheduled;
        this._scheduled = undefined;
        var actions = this.actions;
        var error;
        action = action || actions.shift();
        do {
            if (error = action.execute(action.state, action.delay)) break;
        }while ((action = actions[0]) && action.id === flushId && actions.shift());
        this._active = false;
        if (error) {
            while((action = actions[0]) && action.id === flushId && actions.shift())action.unsubscribe();
            throw error;
        }
    };
    return AnimationFrameScheduler;
}((0, $ef016f6d4d466007$export$4114a3ec92faa3c6));


var $9864f9013a045943$export$4dc84b80a0d0c8da = new (0, $a9319362b2c6ac5f$export$5ac76215a6c70aaa)((0, $6304afbe8e115d4c$export$20b61f85ef6e6915));
var $9864f9013a045943$export$1402cba6a733f33a = $9864f9013a045943$export$4dc84b80a0d0c8da;



var $ba036f2388dbd8ad$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};



function $eb70e2f33aab6e41$export$4369c812aac99591(value) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





var $55472713ab39a4da$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $747d70177225ac2e$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $747d70177225ac2e$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $747d70177225ac2e$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $011e5d1bc8793d8f$export$ebf645db02d3e99f(err) {
    (0, $747d70177225ac2e$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $55472713ab39a4da$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $b1207576672ff0a1$export$8793edee2d425525() {}


var $6e71844eb8fb8894$export$b7f97edb34bc1f87 = function() {
    return $6e71844eb8fb8894$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $6e71844eb8fb8894$export$dd472c3d8fe5a85a(error) {
    return $6e71844eb8fb8894$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $6e71844eb8fb8894$export$ff9346b0d1d30313(value) {
    return $6e71844eb8fb8894$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $6e71844eb8fb8894$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $dee8986d11ecfbd2$var$context = null;
function $dee8986d11ecfbd2$export$d974811edc77eafa(cb) {
    if ((0, $55472713ab39a4da$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$dee8986d11ecfbd2$var$context;
        if (isRoot) $dee8986d11ecfbd2$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $dee8986d11ecfbd2$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $dee8986d11ecfbd2$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $dee8986d11ecfbd2$export$3e205fbb5df021e0(err) {
    if ((0, $55472713ab39a4da$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $dee8986d11ecfbd2$var$context) {
        $dee8986d11ecfbd2$var$context.errorThrown = true;
        $dee8986d11ecfbd2$var$context.error = err;
    }
}


var $4bd741c10f565752$export$60959659b2c22881 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $0c79c60f10e25061$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $4bd741c10f565752$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $4bd741c10f565752$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $4bd741c10f565752$var$handleStoppedNotification((0, $6e71844eb8fb8894$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $4bd741c10f565752$var$handleStoppedNotification((0, $6e71844eb8fb8894$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $4bd741c10f565752$var$handleStoppedNotification((0, $6e71844eb8fb8894$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $0c79c60f10e25061$export$f55210826850c514));
var $4bd741c10f565752$var$_bind = Function.prototype.bind;
function $4bd741c10f565752$var$bind(fn, thisArg) {
    return $4bd741c10f565752$var$_bind.call(fn, thisArg);
}
var $4bd741c10f565752$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $4bd741c10f565752$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $4bd741c10f565752$var$handleUnhandledError(error);
        }
        else $4bd741c10f565752$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $4bd741c10f565752$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $4bd741c10f565752$export$94eeb6a328cab6c7 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $55472713ab39a4da$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $4bd741c10f565752$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $4bd741c10f565752$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $4bd741c10f565752$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $4bd741c10f565752$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($4bd741c10f565752$export$60959659b2c22881);
function $4bd741c10f565752$var$handleUnhandledError(error) {
    if ((0, $55472713ab39a4da$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $dee8986d11ecfbd2$export$3e205fbb5df021e0)(error);
    else (0, $011e5d1bc8793d8f$export$ebf645db02d3e99f)(error);
}
function $4bd741c10f565752$var$defaultErrorHandler(err) {
    throw err;
}
function $4bd741c10f565752$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $55472713ab39a4da$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $747d70177225ac2e$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $4bd741c10f565752$export$88d395d20619a0af = {
    closed: true,
    next: (0, $b1207576672ff0a1$export$8793edee2d425525),
    error: $4bd741c10f565752$var$defaultErrorHandler,
    complete: (0, $b1207576672ff0a1$export$8793edee2d425525)
};



var $9f1965c8ab242a40$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $df305a39c402bbe4$export$f0954fd7d5368655(x) {
    return x;
}


function $d2736e492570b20c$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $d2736e492570b20c$export$71f88a61afaa14d7(fns);
}
function $d2736e492570b20c$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $df305a39c402bbe4$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $2291f71a0036fa02$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $2291f71a0036fa02$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $4bd741c10f565752$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $dee8986d11ecfbd2$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $2291f71a0036fa02$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $4bd741c10f565752$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $9f1965c8ab242a40$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $d2736e492570b20c$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $2291f71a0036fa02$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $2291f71a0036fa02$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $55472713ab39a4da$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $2291f71a0036fa02$var$isObserver(value) {
    return value && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.next) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.error) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.complete);
}
function $2291f71a0036fa02$var$isSubscriber(value) {
    return value && value instanceof (0, $4bd741c10f565752$export$60959659b2c22881) || $2291f71a0036fa02$var$isObserver(value) && (0, $0c79c60f10e25061$export$4f9221cbada3c4fc)(value);
}




function $f1a1ff69d6217eb6$export$48c0cddbc99c45c2(input) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(input[0, $9f1965c8ab242a40$export$5ab46cbf6120b33a]);
}



function $da57935939ca9c16$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $9fbc3ed18d763dea$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $2fe5679b795ca099$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $2fe5679b795ca099$export$6f58e2338da23f4d = $2fe5679b795ca099$export$aa9956be4ae4fe8();



function $82032c4f549f5cd4$export$9652023d9040757(input) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $2fe5679b795ca099$export$6f58e2338da23f4d]);
}




function $42c86ab8e6ccec32$export$cf4785e597badab3(readableStream) {
    return (0, $f5ed4ab2a4d1861b$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $f5ed4ab2a4d1861b$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $f5ed4ab2a4d1861b$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $f5ed4ab2a4d1861b$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $f5ed4ab2a4d1861b$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $42c86ab8e6ccec32$export$c088ffafdba7405f(obj) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $73e1b4b68a4d58ca$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $2291f71a0036fa02$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $f1a1ff69d6217eb6$export$48c0cddbc99c45c2)(input)) return $73e1b4b68a4d58ca$export$aa3d41784b3267fa(input);
        if ((0, $ba036f2388dbd8ad$export$1e2f57719e155213)(input)) return $73e1b4b68a4d58ca$export$4cb2acdbcda2c253(input);
        if ((0, $eb70e2f33aab6e41$export$4369c812aac99591)(input)) return $73e1b4b68a4d58ca$export$60f45028237c39d1(input);
        if ((0, $da57935939ca9c16$export$edb10ab8dd75a915)(input)) return $73e1b4b68a4d58ca$export$e073fccf36d78cc1(input);
        if ((0, $82032c4f549f5cd4$export$9652023d9040757)(input)) return $73e1b4b68a4d58ca$export$dcccc29c315dd646(input);
        if ((0, $42c86ab8e6ccec32$export$c088ffafdba7405f)(input)) return $73e1b4b68a4d58ca$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $9fbc3ed18d763dea$export$7cbe71b9fa263484)(input);
}
function $73e1b4b68a4d58ca$export$aa3d41784b3267fa(obj) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $9f1965c8ab242a40$export$5ab46cbf6120b33a]();
        if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $73e1b4b68a4d58ca$export$4cb2acdbcda2c253(array) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $73e1b4b68a4d58ca$export$60f45028237c39d1(promise) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $011e5d1bc8793d8f$export$ebf645db02d3e99f));
    });
}
function $73e1b4b68a4d58ca$export$dcccc29c315dd646(iterable) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $f5ed4ab2a4d1861b$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $73e1b4b68a4d58ca$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        $73e1b4b68a4d58ca$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $73e1b4b68a4d58ca$export$b2dcb11d46e7a4ad(readableStream) {
    return $73e1b4b68a4d58ca$export$e073fccf36d78cc1((0, $42c86ab8e6ccec32$export$cf4785e597badab3)(readableStream));
}
function $73e1b4b68a4d58ca$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $f5ed4ab2a4d1861b$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $f5ed4ab2a4d1861b$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $f5ed4ab2a4d1861b$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}




function $73cdb159b7187545$export$ebec8610810318c5(source) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $73cdb159b7187545$export$871731df685d7753(init) {
    return function(source) {
        if ($73cdb159b7187545$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}




function $94684df14c25c18c$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $94684df14c25c18c$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $94684df14c25c18c$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $4bd741c10f565752$export$60959659b2c22881));


function $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88(project, thisArg) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}





function $328d0af0ef3aed41$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}



function $03097568c8340eb2$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(resultSelector)) return $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        return (0, $03097568c8340eb2$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}






var $785b56a2951e3f7d$var$isArray = Array.isArray;
function $785b56a2951e3f7d$var$callOrApply(fn, args) {
    return $785b56a2951e3f7d$var$isArray(args) ? fn.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args))) : fn(args);
}
function $785b56a2951e3f7d$export$559affaa48f4288d(fn) {
    return (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(function(args) {
        return $785b56a2951e3f7d$var$callOrApply(fn, args);
    });
}


var $0f54b2b6fdc78d47$var$nodeEventEmitterMethods = [
    "addListener",
    "removeListener"
];
var $0f54b2b6fdc78d47$var$eventTargetMethods = [
    "addEventListener",
    "removeEventListener"
];
var $0f54b2b6fdc78d47$var$jqueryMethods = [
    "on",
    "off"
];
function $0f54b2b6fdc78d47$export$a36e16046ae8f1bb(target, eventName, options, resultSelector) {
    if ((0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(options)) {
        resultSelector = options;
        options = undefined;
    }
    if (resultSelector) return $0f54b2b6fdc78d47$export$a36e16046ae8f1bb(target, eventName, options).pipe((0, $785b56a2951e3f7d$export$559affaa48f4288d)(resultSelector));
    var _a = (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)($0f54b2b6fdc78d47$var$isEventTarget(target) ? $0f54b2b6fdc78d47$var$eventTargetMethods.map(function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler, options);
        };
    }) : $0f54b2b6fdc78d47$var$isNodeStyleEventEmitter(target) ? $0f54b2b6fdc78d47$var$nodeEventEmitterMethods.map($0f54b2b6fdc78d47$var$toCommonHandlerRegistry(target, eventName)) : $0f54b2b6fdc78d47$var$isJQueryStyleEventEmitter(target) ? $0f54b2b6fdc78d47$var$jqueryMethods.map($0f54b2b6fdc78d47$var$toCommonHandlerRegistry(target, eventName)) : [], 2), add = _a[0], remove = _a[1];
    if (!add) {
        if ((0, $ba036f2388dbd8ad$export$1e2f57719e155213)(target)) return (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(function(subTarget) {
            return $0f54b2b6fdc78d47$export$a36e16046ae8f1bb(subTarget, eventName, options);
        })((0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(target));
    }
    if (!add) throw new TypeError("Invalid event target");
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var handler = function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return subscriber.next(1 < args.length ? args : args[0]);
        };
        add(handler);
        return function() {
            return remove(handler);
        };
    });
}
function $0f54b2b6fdc78d47$var$toCommonHandlerRegistry(target, eventName) {
    return function(methodName) {
        return function(handler) {
            return target[methodName](eventName, handler);
        };
    };
}
function $0f54b2b6fdc78d47$var$isNodeStyleEventEmitter(target) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.addListener) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.removeListener);
}
function $0f54b2b6fdc78d47$var$isJQueryStyleEventEmitter(target) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.on) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.off);
}
function $0f54b2b6fdc78d47$var$isEventTarget(target) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.addEventListener) && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(target.removeEventListener);
}



var $194b9793c8de3d4c$export$8d6b71a2b178fc32 = new (0, $ef016f6d4d466007$export$4114a3ec92faa3c6)((0, $2552988672225634$export$b5369ffd7cb2211b));
var $194b9793c8de3d4c$export$12af436354f1a4f7 = $194b9793c8de3d4c$export$8d6b71a2b178fc32;





function $e61bfa90c5c93286$export$187e35932e88c15c(value) {
    return value && (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(value.schedule);
}


function $ed32e809f62b1d15$export$c03bb0116ee09d4b(value) {
    return value instanceof Date && !isNaN(value);
}


function $9848eae097ed6239$export$9dc4ecf953986f04(dueTime, intervalOrScheduler, scheduler) {
    if (dueTime === void 0) dueTime = 0;
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$12af436354f1a4f7);
    var intervalDuration = -1;
    if (intervalOrScheduler != null) {
        if ((0, $e61bfa90c5c93286$export$187e35932e88c15c)(intervalOrScheduler)) scheduler = intervalOrScheduler;
        else intervalDuration = intervalOrScheduler;
    }
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var due = (0, $ed32e809f62b1d15$export$c03bb0116ee09d4b)(dueTime) ? +dueTime - scheduler.now() : dueTime;
        if (due < 0) due = 0;
        var n = 0;
        return scheduler.schedule(function() {
            if (!subscriber.closed) {
                subscriber.next(n++);
                if (0 <= intervalDuration) this.schedule(undefined, intervalDuration);
                else subscriber.complete();
            }
        }, due);
    });
}


function $9835779f37f00b7c$export$3174cdbf0a0cbc84(period, scheduler) {
    if (period === void 0) period = 0;
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$8d6b71a2b178fc32);
    if (period < 0) period = 0;
    return (0, $9848eae097ed6239$export$9dc4ecf953986f04)(period, period, scheduler);
}



function $05216b7046af236d$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)((0, $df305a39c402bbe4$export$f0954fd7d5368655), concurrent);
}




var $ce4337d88b881b98$export$ccb33e29d92c9a58 = new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $ce4337d88b881b98$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $ce4337d88b881b98$var$emptyScheduled(scheduler) : $ce4337d88b881b98$export$ccb33e29d92c9a58;
}
function $ce4337d88b881b98$var$emptyScheduled(scheduler) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}




function $ba29b8cd54e70848$var$last(arr) {
    return arr[arr.length - 1];
}
function $ba29b8cd54e70848$export$9ae19b645239a61b(args) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)($ba29b8cd54e70848$var$last(args)) ? args.pop() : undefined;
}
function $ba29b8cd54e70848$export$29534b2f653ae592(args) {
    return (0, $e61bfa90c5c93286$export$187e35932e88c15c)($ba29b8cd54e70848$var$last(args)) ? args.pop() : undefined;
}
function $ba29b8cd54e70848$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $ba29b8cd54e70848$var$last(args) === "number" ? args.pop() : defaultValue;
}






function $642519524078ad18$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $8c066c1855781072$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $d0634c04e9b810ea$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(input).pipe((0, $8c066c1855781072$export$1eb44d8f5f64733b)(scheduler), (0, $642519524078ad18$export$9007f49c319d1ac7)(scheduler));
}





function $a9da845dce0dee6e$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(input).pipe((0, $8c066c1855781072$export$1eb44d8f5f64733b)(scheduler), (0, $642519524078ad18$export$9007f49c319d1ac7)(scheduler));
}



function $ed6a52c067ec61ae$export$b34673931371729a(input, scheduler) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $5eee238d90d10414$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $2fe5679b795ca099$export$6f58e2338da23f4d]();
            (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $f3a8e4a5f2c234a6$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7148993af86cca65$export$3385251aeecad28a(input, scheduler) {
    return (0, $f3a8e4a5f2c234a6$export$7c7f0979b56a32f3)((0, $42c86ab8e6ccec32$export$cf4785e597badab3)(input), scheduler);
}


function $e8c5e3708251b5fa$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $f1a1ff69d6217eb6$export$48c0cddbc99c45c2)(input)) return (0, $d0634c04e9b810ea$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $ba036f2388dbd8ad$export$1e2f57719e155213)(input)) return (0, $ed6a52c067ec61ae$export$b34673931371729a)(input, scheduler);
        if ((0, $eb70e2f33aab6e41$export$4369c812aac99591)(input)) return (0, $a9da845dce0dee6e$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $da57935939ca9c16$export$edb10ab8dd75a915)(input)) return (0, $f3a8e4a5f2c234a6$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $82032c4f549f5cd4$export$9652023d9040757)(input)) return (0, $5eee238d90d10414$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $42c86ab8e6ccec32$export$c088ffafdba7405f)(input)) return (0, $7148993af86cca65$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $9fbc3ed18d763dea$export$7cbe71b9fa263484)(input);
}



function $afca3285ff834980$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $e8c5e3708251b5fa$export$49c44dfc2bb21d70)(input, scheduler) : (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(input);
}


function $2e63864986133df2$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $ba29b8cd54e70848$export$29534b2f653ae592)(args);
    var concurrent = (0, $ba29b8cd54e70848$export$3de14b735070dcd5)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $ce4337d88b881b98$export$ccb33e29d92c9a58) : sources.length === 1 ? (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(sources[0]) : (0, $05216b7046af236d$export$18aef43295bbe906)(concurrent)((0, $afca3285ff834980$export$6788812c4e6611e6)(sources, scheduler));
}




function $183291bad0f15980$export$9f6ea8e48bc26eab(project, resultSelector) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var innerSubscriber = null;
        var index = 0;
        var isComplete = false;
        var checkComplete = function() {
            return isComplete && !innerSubscriber && subscriber.complete();
        };
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            innerSubscriber === null || innerSubscriber === void 0 || innerSubscriber.unsubscribe();
            var innerIndex = 0;
            var outerIndex = index++;
            (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(project(value, outerIndex)).subscribe(innerSubscriber = (0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(innerValue) {
                return subscriber.next(resultSelector ? resultSelector(value, innerValue, outerIndex, innerIndex++) : innerValue);
            }, function() {
                innerSubscriber = null;
                checkComplete();
            }));
        }, function() {
            isComplete = true;
            checkComplete();
        }));
    });
}





function $4b874ddcbf4a1d4e$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(notifier).subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function() {
            return subscriber.complete();
        }, (0, $b1207576672ff0a1$export$8793edee2d425525)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}





function $992cdff55f780f5c$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $df305a39c402bbe4$export$f0954fd7d5368655);
}


function $b84c8059b1c60c68$var$shoogle(element) {
    const mouseEnter$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(element, "mouseenter");
    const mouseLeave$ = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(element, "mouseleave");
    const hover$ = (0, $2e63864986133df2$export$4950aa0f605343fb)(mouseEnter$, mouseLeave$);
    const interval$ = (0, $9835779f37f00b7c$export$3174cdbf0a0cbc84)(50, (0, $9864f9013a045943$export$4dc84b80a0d0c8da));
    hover$.pipe((0, $183291bad0f15980$export$9f6ea8e48bc26eab)((event)=>{
        if (event.type === "mouseenter") return interval$.pipe((0, $4b874ddcbf4a1d4e$export$ac8dfd3a7ad06e80)(mouseLeave$), (0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>{
            element.style.fontStyle = element.style.fontStyle === "normal" ? "italic" : "normal";
        }));
        else return (0, $9835779f37f00b7c$export$3174cdbf0a0cbc84)(0, (0, $9864f9013a045943$export$4dc84b80a0d0c8da)).pipe((0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>{
            element.style.fontStyle = "normal";
        }));
    })).subscribe();
}
var $b84c8059b1c60c68$export$2e2bcd8739ae039 = $b84c8059b1c60c68$var$shoogle;







var $d007028422acc811$export$f708eee25634bc80 = (0, $18bb82b1635a7e79$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $88dc0495baf4925f$export$b6bbab5a9b109038 = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $88dc0495baf4925f$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $d007028422acc811$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $dee8986d11ecfbd2$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $f5ed4ab2a4d1861b$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $dee8986d11ecfbd2$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $dee8986d11ecfbd2$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $0c79c60f10e25061$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $0c79c60f10e25061$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $fb0c758b8faa1e2a$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $88dc0495baf4925f$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $2291f71a0036fa02$export$77cea355fa80b5f4));
var $88dc0495baf4925f$export$155189cde295587d = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $0c79c60f10e25061$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($88dc0495baf4925f$export$b6bbab5a9b109038);


var $3edc71cdd358c92e$export$cc3d42e6b2b9cf8b = function(_super) {
    (0, $f5ed4ab2a4d1861b$export$a8ba968b8961cb8a)(BehaviorSubject, _super);
    function BehaviorSubject(_value) {
        var _this = _super.call(this) || this;
        _this._value = _value;
        return _this;
    }
    Object.defineProperty(BehaviorSubject.prototype, "value", {
        get: function() {
            return this.getValue();
        },
        enumerable: false,
        configurable: true
    });
    BehaviorSubject.prototype._subscribe = function(subscriber) {
        var subscription = _super.prototype._subscribe.call(this, subscriber);
        !subscription.closed && subscriber.next(this._value);
        return subscription;
    };
    BehaviorSubject.prototype.getValue = function() {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, _value = _a._value;
        if (hasError) throw thrownError;
        this._throwIfClosed();
        return _value;
    };
    BehaviorSubject.prototype.next = function(value) {
        _super.prototype.next.call(this, this._value = value);
    };
    return BehaviorSubject;
}((0, $88dc0495baf4925f$export$b6bbab5a9b109038));




function $1e84b4bbfc1f6906$export$3dede90624df3ba9(selector) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var innerSub = null;
        var syncUnsub = false;
        var handledResult;
        innerSub = source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, undefined, undefined, function(err) {
            handledResult = (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(selector(err, $1e84b4bbfc1f6906$export$3dede90624df3ba9(selector)(source)));
            if (innerSub) {
                innerSub.unsubscribe();
                innerSub = null;
                handledResult.subscribe(subscriber);
            } else syncUnsub = true;
        }));
        if (syncUnsub) {
            innerSub.unsubscribe();
            innerSub = null;
            handledResult.subscribe(subscriber);
        }
    });
}


var $1f33917ee6b22d08$var$isArray = Array.isArray;
var $1f33917ee6b22d08$var$getPrototypeOf = Object.getPrototypeOf, $1f33917ee6b22d08$var$objectProto = Object.prototype, $1f33917ee6b22d08$var$getKeys = Object.keys;
function $1f33917ee6b22d08$export$8871b3799a14360f(args) {
    if (args.length === 1) {
        var first_1 = args[0];
        if ($1f33917ee6b22d08$var$isArray(first_1)) return {
            args: first_1,
            keys: null
        };
        if ($1f33917ee6b22d08$var$isPOJO(first_1)) {
            var keys = $1f33917ee6b22d08$var$getKeys(first_1);
            return {
                args: keys.map(function(key) {
                    return first_1[key];
                }),
                keys: keys
            };
        }
    }
    return {
        args: args,
        keys: null
    };
}
function $1f33917ee6b22d08$var$isPOJO(obj) {
    return obj && typeof obj === "object" && $1f33917ee6b22d08$var$getPrototypeOf(obj) === $1f33917ee6b22d08$var$objectProto;
}






function $d41e8da0fa7245a0$export$79c7e160a7743efd(keys, values) {
    return keys.reduce(function(result, key, i) {
        return result[key] = values[i], result;
    }, {});
}




function $4c3b7d6e02634e4a$export$77fa7d86f5204e8a() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $ba29b8cd54e70848$export$29534b2f653ae592)(args);
    var resultSelector = (0, $ba29b8cd54e70848$export$9ae19b645239a61b)(args);
    var _a = (0, $1f33917ee6b22d08$export$8871b3799a14360f)(args), observables = _a.args, keys = _a.keys;
    if (observables.length === 0) return (0, $afca3285ff834980$export$6788812c4e6611e6)([], scheduler);
    var result = new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)($4c3b7d6e02634e4a$export$f04dcfb475ed2128(observables, scheduler, keys ? function(values) {
        return (0, $d41e8da0fa7245a0$export$79c7e160a7743efd)(keys, values);
    } : (0, $df305a39c402bbe4$export$f0954fd7d5368655)));
    return resultSelector ? result.pipe((0, $785b56a2951e3f7d$export$559affaa48f4288d)(resultSelector)) : result;
}
function $4c3b7d6e02634e4a$export$f04dcfb475ed2128(observables, scheduler, valueTransform) {
    if (valueTransform === void 0) valueTransform = (0, $df305a39c402bbe4$export$f0954fd7d5368655);
    return function(subscriber) {
        $4c3b7d6e02634e4a$var$maybeSchedule(scheduler, function() {
            var length = observables.length;
            var values = new Array(length);
            var active = length;
            var remainingFirstValues = length;
            var _loop_1 = function(i) {
                $4c3b7d6e02634e4a$var$maybeSchedule(scheduler, function() {
                    var source = (0, $afca3285ff834980$export$6788812c4e6611e6)(observables[i], scheduler);
                    var hasFirstValue = false;
                    source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
                        values[i] = value;
                        if (!hasFirstValue) {
                            hasFirstValue = true;
                            remainingFirstValues--;
                        }
                        if (!remainingFirstValues) subscriber.next(valueTransform(values.slice()));
                    }, function() {
                        if (!--active) subscriber.complete();
                    }));
                }, subscriber);
            };
            for(var i = 0; i < length; i++)_loop_1(i);
        }, subscriber);
    };
}
function $4c3b7d6e02634e4a$var$maybeSchedule(scheduler, execute, subscription) {
    if (scheduler) (0, $328d0af0ef3aed41$export$a2b7447487315232)(subscription, scheduler, execute);
    else execute();
}



function $3cf7bf86af55a3de$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}


function $e8f8d6a497df44f8$export$b314777ae20abca9() {
    return (0, $05216b7046af236d$export$18aef43295bbe906)(1);
}




function $4195388abc69bf39$export$ee1b3e54f0441b22() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return (0, $e8f8d6a497df44f8$export$b314777ae20abca9)()((0, $afca3285ff834980$export$6788812c4e6611e6)(args, (0, $ba29b8cd54e70848$export$29534b2f653ae592)(args)));
}




function $7614a06bb9dad2f3$export$a4fe86229b0e9bdd() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    var scheduler = (0, $ba29b8cd54e70848$export$29534b2f653ae592)(values);
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        (scheduler ? (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(values, source, scheduler) : (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(values, source)).subscribe(subscriber);
    });
}








function $3e615a6023dd2365$export$d449030e5c10edf7() {
    var inputs = [];
    for(var _i = 0; _i < arguments.length; _i++)inputs[_i] = arguments[_i];
    var project = (0, $ba29b8cd54e70848$export$9ae19b645239a61b)(inputs);
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var len = inputs.length;
        var otherValues = new Array(len);
        var hasValue = inputs.map(function() {
            return false;
        });
        var ready = false;
        var _loop_1 = function(i) {
            (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(inputs[i]).subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
                otherValues[i] = value;
                if (!ready && !hasValue[i]) {
                    hasValue[i] = true;
                    (ready = hasValue.every((0, $df305a39c402bbe4$export$f0954fd7d5368655))) && (hasValue = null);
                }
            }, (0, $b1207576672ff0a1$export$8793edee2d425525)));
        };
        for(var i = 0; i < len; i++)_loop_1(i);
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            if (ready) {
                var values = (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([
                    value
                ], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(otherValues));
                subscriber.next(project ? project.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(values))) : values);
            }
        }));
    });
}


var $dcd4e94b4ab65c1f$var$t = {
    table: "directus_collections",
    defaults: {
        collection: null,
        hidden: !1,
        singleton: !1,
        icon: null,
        note: null,
        translations: null,
        display_template: null,
        accountability: "all"
    },
    data: [
        {
            collection: "directus_activity",
            note: "$t:directus_collection.directus_activity",
            accountability: null
        },
        {
            collection: "directus_collections",
            icon: "database",
            note: "$t:directus_collection.directus_collections"
        },
        {
            collection: "directus_fields",
            icon: "input",
            note: "$t:directus_collection.directus_fields"
        },
        {
            collection: "directus_files",
            icon: "folder",
            note: "$t:directus_collection.directus_files",
            display_template: "{{ $thumbnail }} {{ title }}"
        },
        {
            collection: "directus_folders",
            note: "$t:directus_collection.directus_folders",
            display_template: "{{ name }}"
        },
        {
            collection: "directus_migrations",
            note: "$t:directus_collection.directus_migrations"
        },
        {
            collection: "directus_permissions",
            icon: "admin_panel_settings",
            note: "$t:directus_collection.directus_permissions"
        },
        {
            collection: "directus_presets",
            icon: "bookmark",
            note: "$t:directus_collection.directus_presets",
            accountability: null
        },
        {
            collection: "directus_relations",
            icon: "merge_type",
            note: "$t:directus_collection.directus_relations"
        },
        {
            collection: "directus_revisions",
            note: "$t:directus_collection.directus_revisions",
            accountability: null
        },
        {
            collection: "directus_roles",
            icon: "supervised_user_circle",
            note: "$t:directus_collection.directus_roles"
        },
        {
            collection: "directus_sessions",
            note: "$t:directus_collection.directus_sessions"
        },
        {
            collection: "directus_settings",
            singleton: !0,
            note: "$t:directus_collection.directus_settings"
        },
        {
            collection: "directus_users",
            archive_field: "status",
            archive_value: "archived",
            unarchive_value: "draft",
            icon: "people_alt",
            note: "$t:directus_collection.directus_users",
            display_template: "{{ first_name }} {{ last_name }}"
        },
        {
            collection: "directus_webhooks",
            note: "$t:directus_collection.directus_webhooks"
        },
        {
            collection: "directus_dashboards",
            note: "$t:directus_collection.directus_dashboards"
        },
        {
            collection: "directus_panels",
            note: "$t:directus_collection.directus_panels"
        },
        {
            collection: "directus_notifications",
            note: "$t:directus_collection.directus_notifications"
        },
        {
            collection: "directus_shares",
            icon: "share",
            note: "$t:directus_collection.directus_shares"
        },
        {
            collection: "directus_flows",
            note: "$t:directus_collection.directus_flows"
        },
        {
            collection: "directus_operations",
            note: "$t:directus_collection.directus_operations"
        },
        {
            collection: "directus_translations",
            note: "$t:directus_collection.directus_translations"
        },
        {
            collection: "directus_versions",
            note: "$t:directus_collection.directus_versions"
        },
        {
            collection: "directus_extensions",
            note: "$t:directus_collection.directus_extensions"
        }
    ]
};
var $dcd4e94b4ab65c1f$export$e55dc0cb96778745 = $dcd4e94b4ab65c1f$var$t.data.map((i)=>({
        ...$dcd4e94b4ab65c1f$var$t.defaults,
        ...i,
        system: !0
    })), $dcd4e94b4ab65c1f$export$d8b317b41445d479 = $dcd4e94b4ab65c1f$var$t.data.map((i)=>i.collection);
function $dcd4e94b4ab65c1f$export$f4f5d58c6b1bdc44(i) {
    return $dcd4e94b4ab65c1f$export$d8b317b41445d479.includes(i);
}
var $dcd4e94b4ab65c1f$var$l = {
    table: "directus_relations",
    defaults: {
        many_collection: "directus_users",
        many_field: null,
        one_collection: null,
        one_field: null,
        one_allowed_collections: null,
        one_collection_field: null,
        one_deselect_action: "nullify",
        junction_field: null,
        sort_field: null
    },
    data: [
        {
            many_collection: "directus_collections",
            many_field: "group",
            one_collection: "directus_collections"
        },
        {
            many_collection: "directus_users",
            many_field: "role",
            one_collection: "directus_roles",
            one_field: "users"
        },
        {
            many_collection: "directus_users",
            many_field: "avatar",
            one_collection: "directus_files"
        },
        {
            many_collection: "directus_revisions",
            many_field: "activity",
            one_collection: "directus_activity",
            one_field: "revisions"
        },
        {
            many_collection: "directus_revisions",
            many_field: "parent",
            one_collection: "directus_revisions"
        },
        {
            many_collection: "directus_revisions",
            many_field: "version",
            one_collection: "directus_versions"
        },
        {
            many_collection: "directus_presets",
            many_field: "user",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_presets",
            many_field: "role",
            one_collection: "directus_roles"
        },
        {
            many_collection: "directus_folders",
            many_field: "parent",
            one_collection: "directus_folders"
        },
        {
            many_collection: "directus_files",
            many_field: "folder",
            one_collection: "directus_folders"
        },
        {
            many_collection: "directus_files",
            many_field: "uploaded_by",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_files",
            many_field: "modified_by",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_fields",
            many_field: "collection",
            one_collection: "directus_collections",
            one_field: "fields"
        },
        {
            many_collection: "directus_fields",
            many_field: "group",
            one_collection: "directus_fields"
        },
        {
            many_collection: "directus_activity",
            many_field: "user",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_settings",
            many_field: "project_logo",
            one_collection: "directus_files"
        },
        {
            many_collection: "directus_settings",
            many_field: "public_foreground",
            one_collection: "directus_files"
        },
        {
            many_collection: "directus_settings",
            many_field: "public_background",
            one_collection: "directus_files"
        },
        {
            many_collection: "directus_settings",
            many_field: "public_favicon",
            one_collection: "directus_files"
        },
        {
            many_collection: "directus_settings",
            many_field: "storage_default_folder",
            one_collection: "directus_folders"
        },
        {
            many_collection: "directus_panels",
            many_field: "dashboard",
            one_collection: "directus_dashboards",
            one_field: "panels"
        },
        {
            many_collection: "directus_panels",
            many_field: "user_created",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_flows",
            many_field: "operation",
            one_collection: "directus_operations"
        },
        {
            many_collection: "directus_flows",
            many_field: "user_created",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_operations",
            many_field: "flow",
            one_collection: "directus_flows",
            one_field: "operations",
            one_deselect_action: "delete"
        },
        {
            many_collection: "directus_operations",
            many_field: "resolve",
            one_collection: "directus_operations"
        },
        {
            many_collection: "directus_operations",
            many_field: "reject",
            one_collection: "directus_operations"
        },
        {
            many_collection: "directus_operations",
            many_field: "user_created",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_permissions",
            many_field: "role",
            one_collection: "directus_roles"
        },
        {
            many_collection: "directus_sessions",
            many_field: "user",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_sessions",
            many_field: "share",
            one_collection: "directus_shares"
        },
        {
            many_collection: "directus_dashboards",
            many_field: "user_created",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_notifications",
            many_field: "recipient",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_notifications",
            many_field: "sender",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_shares",
            many_field: "role",
            one_collection: "directus_roles"
        },
        {
            many_collection: "directus_shares",
            many_field: "collection",
            one_collection: "directus_collections"
        },
        {
            many_collection: "directus_shares",
            many_field: "user_created",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_versions",
            many_field: "collection",
            one_collection: "directus_collections"
        },
        {
            many_collection: "directus_versions",
            many_field: "user_created",
            one_collection: "directus_users"
        },
        {
            many_collection: "directus_versions",
            many_field: "user_updated",
            one_collection: "directus_users"
        }
    ]
};
var $dcd4e94b4ab65c1f$export$ff145bb4a107b1e = $dcd4e94b4ab65c1f$var$l.data.map((i)=>({
        ...$dcd4e94b4ab65c1f$var$l.defaults,
        ...i,
        system: !0
    }));
var $dcd4e94b4ab65c1f$var$o = {
    collection: null,
    field: null,
    special: null,
    interface: null,
    options: null,
    display: null,
    display_options: null,
    readonly: !1,
    hidden: !1,
    sort: null,
    width: "full",
    group: null,
    translations: null,
    note: null,
    conditions: null,
    required: !1
};
var $dcd4e94b4ab65c1f$var$a = {
    table: "directus_activity",
    fields: [
        {
            field: "id",
            width: "half"
        },
        {
            field: "item",
            width: "half"
        },
        {
            field: "action",
            display: "labels",
            display_options: {
                choices: [
                    {
                        text: "$t:field_options.directus_activity.create",
                        value: "create",
                        foreground: "var(--theme--primary)",
                        background: "var(--theme--primary-subdued)"
                    },
                    {
                        text: "$t:field_options.directus_activity.update",
                        value: "update",
                        foreground: "var(--blue)",
                        background: "var(--blue-25)"
                    },
                    {
                        text: "$t:field_options.directus_activity.delete",
                        value: "delete",
                        foreground: "var(--theme--danger)",
                        background: "var(--danger-25)"
                    },
                    {
                        text: "$t:field_options.directus_activity.login",
                        value: "login",
                        foreground: "var(--purple)",
                        background: "var(--purple-25)"
                    }
                ]
            },
            width: "half"
        },
        {
            field: "collection",
            display: "collection",
            display_options: {
                icon: !0
            },
            width: "half"
        },
        {
            field: "timestamp",
            display: "datetime",
            special: [
                "date-created",
                "cast-timestamp"
            ],
            options: {
                relative: !0
            },
            width: "half"
        },
        {
            field: "user",
            display: "user",
            width: "half"
        },
        {
            field: "comment",
            display: "formatted-value",
            display_options: {
                color: "var(--theme--foreground-subdued)"
            },
            width: "half"
        },
        {
            field: "user_agent",
            display: "formatted-value",
            display_options: {
                font: "monospace"
            },
            width: "half"
        },
        {
            field: "origin",
            display: "formatted-value",
            display_options: {
                font: "monospace"
            },
            width: "half"
        },
        {
            field: "ip",
            display: "formatted-value",
            display_options: {
                font: "monospace"
            },
            width: "half"
        },
        {
            field: "revisions",
            interface: "list-o2m",
            special: [
                "o2m"
            ],
            options: {
                fields: [
                    "collection",
                    "item"
                ]
            },
            width: "half"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$s = {
    table: "directus_collections",
    fields: [
        {
            field: "collection_divider",
            special: [
                "alias",
                "no-data"
            ],
            interface: "presentation-divider",
            options: {
                icon: "box",
                title: "$t:field_options.directus_collections.collection_setup"
            },
            width: "full"
        },
        {
            field: "collection",
            interface: "input",
            options: {
                font: "monospace"
            },
            readonly: !0,
            width: "half"
        },
        {
            field: "note",
            interface: "input",
            options: {
                placeholder: "$t:field_options.directus_collections.note_placeholder"
            },
            width: "half"
        },
        {
            field: "icon",
            interface: "select-icon",
            options: null,
            width: "half"
        },
        {
            field: "color",
            interface: "select-color",
            options: {
                placeholder: "$t:interfaces.select-color.placeholder"
            },
            width: "half"
        },
        {
            field: "display_template",
            interface: "system-display-template",
            options: {
                collectionField: "collection"
            },
            width: "full"
        },
        {
            field: "hidden",
            special: [
                "cast-boolean"
            ],
            interface: "boolean",
            options: {
                label: "$t:field_options.directus_collections.hidden_label"
            },
            width: "half"
        },
        {
            field: "singleton",
            special: [
                "cast-boolean"
            ],
            interface: "boolean",
            options: {
                label: "$t:singleton_label"
            },
            width: "half"
        },
        {
            field: "translations",
            special: [
                "cast-json"
            ],
            interface: "list",
            options: {
                template: "{{ translation }} ({{ language }})",
                fields: [
                    {
                        field: "language",
                        name: "$t:language",
                        type: "string",
                        schema: {
                            default_value: "en-US"
                        },
                        meta: {
                            interface: "system-language",
                            width: "half",
                            required: !0
                        }
                    },
                    {
                        field: "translation",
                        name: "$t:field_options.directus_collections.collection_name",
                        type: "string",
                        meta: {
                            interface: "input",
                            width: "half",
                            required: !0,
                            options: {
                                placeholder: "$t:field_options.directus_collections.translation_placeholder"
                            }
                        }
                    },
                    {
                        field: "singular",
                        name: "$t:field_options.directus_collections.singular_unit",
                        type: "string",
                        meta: {
                            interface: "input",
                            width: "half",
                            options: {
                                placeholder: "$t:field_options.directus_collections.translation_placeholder"
                            }
                        }
                    },
                    {
                        field: "plural",
                        name: "$t:field_options.directus_collections.plural_unit",
                        type: "string",
                        meta: {
                            interface: "input",
                            width: "half",
                            options: {
                                placeholder: "$t:field_options.directus_collections.translation_placeholder"
                            }
                        }
                    }
                ]
            },
            width: "full"
        },
        {
            field: "preview_divider",
            special: [
                "alias",
                "no-data"
            ],
            interface: "presentation-divider",
            options: {
                icon: "preview",
                title: "$t:field_options.directus_collections.preview_divider"
            },
            width: "full"
        },
        {
            field: "preview_url",
            interface: "system-display-template",
            options: {
                collectionField: "collection",
                injectVersionField: !0
            },
            width: "full"
        },
        {
            field: "content_versioning_divider",
            special: [
                "alias",
                "no-data"
            ],
            interface: "presentation-divider",
            options: {
                icon: "published_with_changes",
                title: "$t:field_options.directus_collections.content_versioning_divider"
            },
            width: "full"
        },
        {
            field: "versioning",
            interface: "boolean",
            special: [
                "cast-boolean"
            ],
            options: {
                label: "$t:field_options.directus_collections.enable_versioning"
            },
            width: "half"
        },
        {
            field: "archive_divider",
            special: [
                "alias",
                "no-data"
            ],
            interface: "presentation-divider",
            options: {
                icon: "archive",
                title: "$t:field_options.directus_collections.archive_divider"
            },
            width: "full"
        },
        {
            field: "archive_field",
            interface: "system-field",
            options: {
                collectionField: "collection",
                allowNone: !0,
                placeholder: "$t:field_options.directus_collections.archive_field_placeholder"
            },
            width: "half"
        },
        {
            field: "archive_app_filter",
            interface: "boolean",
            special: [
                "cast-boolean"
            ],
            options: {
                label: "$t:field_options.directus_collections.archive_app_filter"
            },
            width: "half"
        },
        {
            field: "archive_value",
            interface: "input",
            options: {
                font: "monospace",
                iconRight: "archive",
                placeholder: "$t:field_options.directus_collections.archive_value"
            },
            width: "half"
        },
        {
            field: "unarchive_value",
            interface: "input",
            options: {
                font: "monospace",
                iconRight: "unarchive",
                placeholder: "$t:field_options.directus_collections.unarchive_value"
            },
            width: "half"
        },
        {
            field: "sort_divider",
            special: [
                "alias",
                "no-data"
            ],
            interface: "presentation-divider",
            options: {
                icon: "sort",
                title: "$t:field_options.directus_collections.sort_divider"
            },
            width: "full"
        },
        {
            field: "sort_field",
            interface: "system-field",
            options: {
                collectionField: "collection",
                placeholder: "$t:field_options.directus_collections.sort_field",
                typeAllowList: [
                    "float",
                    "decimal",
                    "integer"
                ],
                allowNone: !0,
                allowPrimaryKey: !1,
                allowForeignKeys: !1
            },
            width: "half"
        },
        {
            field: "accountability_divider",
            special: [
                "alias",
                "no-data"
            ],
            interface: "presentation-divider",
            options: {
                icon: "admin_panel_settings",
                title: "$t:field_options.directus_collections.accountability_divider"
            },
            width: "full"
        },
        {
            field: "accountability",
            interface: "select-dropdown",
            options: {
                choices: [
                    {
                        text: "$t:field_options.directus_collections.track_activity_revisions",
                        value: "all"
                    },
                    {
                        text: "$t:field_options.directus_collections.only_track_activity",
                        value: "activity"
                    },
                    {
                        text: "$t:field_options.directus_collections.do_not_track_anything",
                        value: null
                    }
                ]
            },
            width: "half"
        },
        {
            field: "duplication_divider",
            special: [
                "alias",
                "no-data"
            ],
            interface: "presentation-divider",
            options: {
                icon: "content_copy",
                title: "$t:field_options.directus_collections.duplication_divider"
            }
        },
        {
            field: "item_duplication_fields",
            special: [
                "cast-json"
            ],
            interface: "system-field-tree",
            options: {
                collectionField: "collection"
            }
        },
        {
            field: "sort",
            hidden: !0
        },
        {
            field: "group",
            hidden: !0
        },
        {
            field: "collapse",
            hidden: !0
        }
    ]
};
var $dcd4e94b4ab65c1f$var$n = {
    table: "directus_fields",
    fields: [
        {
            collection: "directus_fields",
            field: "id",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "collection",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "field",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "special",
            hidden: !0,
            special: [
                "cast-csv"
            ],
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "interface",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "options",
            hidden: !0,
            special: [
                "cast-json"
            ],
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "display",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "display_options",
            hidden: !0,
            special: [
                "cast-json"
            ],
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "readonly",
            hidden: !0,
            special: [
                "cast-boolean"
            ],
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "hidden",
            hidden: !0,
            special: [
                "cast-boolean"
            ],
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "required",
            hidden: !0,
            special: [
                "cast-boolean"
            ],
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "sort",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "width",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "group",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "translations",
            hidden: !0,
            special: [
                "cast-json"
            ],
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "note",
            width: "half"
        },
        {
            collection: "directus_fields",
            field: "conditions",
            hidden: !0,
            special: [
                "cast-json"
            ]
        },
        {
            collection: "directus_fields",
            field: "validation",
            hidden: !0,
            special: [
                "cast-json"
            ]
        },
        {
            collection: "directus_fields",
            field: "validation_message",
            hidden: !0
        }
    ]
};
var $dcd4e94b4ab65c1f$var$d = {
    table: "directus_files",
    fields: [
        {
            field: "id",
            hidden: !0,
            interface: "input",
            special: [
                "uuid"
            ]
        },
        {
            field: "title",
            interface: "input",
            options: {
                iconRight: "title",
                placeholder: "$t:field_options.directus_files.title"
            },
            width: "full"
        },
        {
            field: "description",
            interface: "input-multiline",
            width: "full",
            options: {
                placeholder: "$t:field_options.directus_files.description"
            }
        },
        {
            field: "tags",
            interface: "tags",
            options: {
                iconRight: "local_offer"
            },
            special: [
                "cast-json"
            ],
            width: "full",
            display: "labels",
            display_options: {
                choices: null,
                format: !1
            }
        },
        {
            field: "location",
            interface: "input",
            options: {
                iconRight: "place",
                placeholder: "$t:field_options.directus_files.location"
            },
            width: "half"
        },
        {
            field: "storage",
            interface: "input",
            options: {
                iconRight: "storage"
            },
            width: "half",
            readonly: !0
        },
        {
            field: "focal_point_divider",
            interface: "presentation-divider",
            options: {
                icon: "image_search",
                title: "$t:field_options.directus_files.focal_point_divider"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "focal_point_x",
            width: "half"
        },
        {
            field: "focal_point_y",
            width: "half"
        },
        {
            field: "storage_divider",
            interface: "presentation-divider",
            options: {
                icon: "insert_drive_file",
                title: "$t:field_options.directus_files.storage_divider"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "filename_disk",
            interface: "input",
            options: {
                iconRight: "publish",
                placeholder: "$t:field_options.directus_files.filename_disk"
            },
            readonly: !0,
            width: "half"
        },
        {
            field: "filename_download",
            interface: "input",
            options: {
                iconRight: "get_app",
                placeholder: "$t:field_options.directus_files.filename_download"
            },
            width: "half"
        },
        {
            field: "metadata",
            hidden: !0,
            special: [
                "cast-json"
            ]
        },
        {
            field: "type",
            display: "mime-type",
            readonly: !0
        },
        {
            field: "filesize",
            display: "filesize",
            readonly: !0
        },
        {
            field: "modified_by",
            interface: "select-dropdown-m2o",
            special: [
                "user-updated"
            ],
            width: "half",
            display: "user",
            readonly: !0,
            options: {
                template: "{{avatar.$thumbnail}} {{first_name}} {{last_name}}"
            }
        },
        {
            field: "modified_on",
            interface: "datetime",
            special: [
                "date-updated"
            ],
            width: "half",
            display: "datetime",
            readonly: !0
        },
        {
            field: "embed",
            width: "half",
            hidden: !0
        },
        {
            field: "uploaded_by",
            display: "user",
            width: "half",
            hidden: !0,
            special: [
                "user-created"
            ]
        },
        {
            field: "uploaded_on",
            display: "datetime",
            width: "half",
            hidden: !0
        },
        {
            field: "folder",
            width: "half",
            readonly: !0,
            special: [
                "m2o"
            ],
            display: "related-values",
            display_options: {
                template: "{{ name }}"
            }
        },
        {
            field: "width",
            width: "half",
            readonly: !0
        },
        {
            field: "height",
            width: "half",
            readonly: !0
        },
        {
            field: "charset",
            width: "half",
            readonly: !0
        },
        {
            field: "duration",
            width: "half",
            readonly: !0
        }
    ]
};
var $dcd4e94b4ab65c1f$var$r = {
    table: "directus_folders",
    fields: [
        {
            field: "id",
            interface: "input",
            special: [
                "uuid"
            ],
            width: "half"
        },
        {
            field: "parent",
            width: "half"
        },
        {
            field: "name",
            width: "full"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$c = {
    table: "directus_migrations",
    fields: [
        {
            collection: "directus_migrations",
            field: "version"
        },
        {
            collection: "directus_migrations",
            field: "name"
        },
        {
            collection: "directus_migrations",
            field: "timestamp"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$f = {
    table: "directus_permissions",
    fields: [
        {
            field: "permissions",
            hidden: !0,
            special: [
                "cast-json"
            ],
            width: "half"
        },
        {
            field: "presets",
            hidden: !0,
            special: [
                "cast-json"
            ],
            width: "half"
        },
        {
            field: "role",
            width: "half"
        },
        {
            field: "collection",
            width: "half"
        },
        {
            field: "id",
            width: "half"
        },
        {
            field: "fields",
            width: "half",
            special: [
                "cast-csv"
            ]
        },
        {
            field: "action",
            width: "half"
        },
        {
            field: "validation",
            width: "half",
            special: [
                "cast-json"
            ]
        }
    ]
};
var $dcd4e94b4ab65c1f$var$u = {
    table: "directus_presets",
    fields: [
        {
            field: "filter",
            hidden: !0,
            special: [
                "cast-json"
            ]
        },
        {
            field: "layout_query",
            hidden: !0,
            special: [
                "cast-json"
            ]
        },
        {
            field: "layout_options",
            hidden: !0,
            special: [
                "cast-json"
            ]
        },
        {
            field: "role",
            width: "half",
            special: [
                "m2o"
            ],
            display: "related-values",
            display_options: {
                template: "{{ name }}"
            }
        },
        {
            field: "user",
            width: "half",
            special: [
                "m2o"
            ],
            display: "related-values",
            display_options: {
                template: "{{ email }}"
            }
        },
        {
            field: "id",
            width: "half"
        },
        {
            field: "bookmark",
            width: "half"
        },
        {
            field: "icon",
            width: "half"
        },
        {
            field: "color",
            width: "half"
        },
        {
            field: "search",
            width: "half"
        },
        {
            field: "collection",
            width: "half"
        },
        {
            field: "layout",
            width: "half"
        },
        {
            field: "refresh_interval"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$p = {
    table: "directus_relations",
    fields: [
        {
            field: "id",
            width: "half"
        },
        {
            field: "many_collection",
            width: "half"
        },
        {
            field: "many_field",
            width: "half"
        },
        {
            field: "one_collection",
            width: "half"
        },
        {
            field: "one_field",
            width: "half"
        },
        {
            field: "one_collection_field",
            width: "half"
        },
        {
            field: "one_allowed_collections",
            special: [
                "cast-csv"
            ],
            width: "half"
        },
        {
            field: "junction_field",
            width: "half"
        },
        {
            field: "sort_field",
            width: "half"
        },
        {
            field: "one_deselect_action",
            width: "half"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$_ = {
    table: "directus_revisions",
    fields: [
        {
            field: "id",
            width: "half"
        },
        {
            field: "activity",
            width: "half"
        },
        {
            field: "collection",
            width: "half"
        },
        {
            field: "item",
            width: "half"
        },
        {
            field: "data",
            hidden: !0,
            special: [
                "cast-json"
            ]
        },
        {
            field: "delta",
            hidden: !0,
            special: [
                "cast-json"
            ]
        },
        {
            field: "parent",
            width: "half"
        },
        {
            field: "version",
            width: "half"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$h = {
    table: "directus_roles",
    fields: [
        {
            field: "id",
            hidden: !0,
            interface: "input",
            special: [
                "uuid"
            ]
        },
        {
            field: "name",
            interface: "input",
            options: {
                placeholder: "$t:field_options.directus_roles.name"
            },
            width: "half"
        },
        {
            field: "icon",
            interface: "select-icon",
            display: "icon",
            width: "half"
        },
        {
            field: "description",
            interface: "input",
            options: {
                placeholder: "$t:field_options.directus_roles.description"
            },
            width: "full"
        },
        {
            field: "app_access",
            interface: "boolean",
            special: [
                "cast-boolean"
            ],
            width: "half"
        },
        {
            field: "admin_access",
            interface: "boolean",
            special: [
                "cast-boolean"
            ],
            width: "half"
        },
        {
            field: "ip_access",
            interface: "tags",
            options: {
                placeholder: "$t:field_options.directus_roles.ip_access"
            },
            special: [
                "cast-csv"
            ],
            width: "full"
        },
        {
            field: "enforce_tfa",
            interface: "boolean",
            special: [
                "cast-boolean"
            ],
            width: "half"
        },
        {
            field: "users",
            interface: "list-o2m",
            special: [
                "o2m"
            ],
            options: {
                fields: [
                    "first_name",
                    "last_name"
                ]
            },
            width: "full"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$m = {
    table: "directus_sessions",
    fields: [
        {
            field: "token",
            width: "half"
        },
        {
            field: "user",
            width: "half"
        },
        {
            field: "expires",
            width: "half"
        },
        {
            field: "ip",
            width: "half"
        },
        {
            field: "user_agent",
            width: "half"
        },
        {
            field: "origin",
            width: "half"
        },
        {
            field: "share"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$g = {
    table: "directus_settings",
    fields: [
        {
            field: "id",
            hidden: !0
        },
        {
            field: "project_name",
            interface: "input",
            options: {
                iconRight: "title",
                placeholder: "$t:field_options.directus_settings.project_name_placeholder"
            },
            width: "half"
        },
        {
            field: "project_descriptor",
            interface: "input",
            options: {
                iconRight: "title",
                placeholder: "$t:field_options.directus_settings.project_name_placeholder"
            },
            width: "half"
        },
        {
            field: "project_url",
            interface: "input",
            options: {
                iconRight: "link",
                placeholder: "https://example.com"
            },
            width: "half"
        },
        {
            field: "default_language",
            interface: "system-language",
            options: {
                iconRight: "language",
                placeholder: "en-US"
            },
            width: "half"
        },
        {
            field: "theming_group",
            interface: "group-raw",
            special: [
                "alias",
                "no-data",
                "group"
            ]
        },
        {
            field: "branding_divider",
            interface: "presentation-divider",
            options: {
                icon: "palette",
                title: "$t:fields.directus_settings.branding"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full",
            group: "theming_group"
        },
        {
            field: "project_color",
            interface: "select-color",
            note: "$t:field_options.directus_settings.project_color_note",
            width: "half",
            group: "theming_group"
        },
        {
            field: "project_logo",
            interface: "file",
            note: "$t:field_options.directus_settings.project_logo_note",
            width: "half",
            group: "theming_group"
        },
        {
            field: "public_foreground",
            interface: "file",
            width: "half",
            group: "theming_group"
        },
        {
            field: "public_background",
            interface: "file",
            width: "half",
            group: "theming_group"
        },
        {
            field: "public_favicon",
            interface: "file",
            note: "$t:field_options.directus_settings.project_favicon_note",
            width: "half",
            group: "theming_group"
        },
        {
            field: "public_note",
            interface: "input",
            options: {
                placeholder: "$t:field_options.directus_settings.public_note_placeholder",
                iconRight: "info"
            },
            width: "half",
            group: "theming_group"
        },
        {
            field: "theming_divider",
            interface: "presentation-divider",
            options: {
                icon: "palette",
                title: "$t:fields.directus_settings.theming"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full",
            group: "theming_group"
        },
        {
            field: "default_appearance",
            interface: "select-dropdown",
            width: "half",
            options: {
                choices: [
                    {
                        value: "auto",
                        text: "$t:appearance_auto"
                    },
                    {
                        value: "light",
                        text: "$t:appearance_light"
                    },
                    {
                        value: "dark",
                        text: "$t:appearance_dark"
                    }
                ]
            },
            group: "theming_group"
        },
        {
            field: "default_theme_light",
            width: "full",
            interface: "system-theme",
            options: {
                appearance: "light"
            },
            group: "theming_group"
        },
        {
            field: "theme_light_overrides",
            width: "full",
            interface: "system-theme-overrides",
            options: {
                appearance: "light"
            },
            group: "theming_group",
            special: [
                "cast-json"
            ]
        },
        {
            field: "default_theme_dark",
            width: "full",
            interface: "system-theme",
            options: {
                appearance: "dark"
            },
            group: "theming_group"
        },
        {
            field: "theme_dark_overrides",
            width: "full",
            interface: "system-theme-overrides",
            options: {
                appearance: "dark"
            },
            group: "theming_group",
            special: [
                "cast-json"
            ]
        },
        {
            field: "custom_css",
            interface: "input-code",
            options: {
                language: "css",
                lineNumber: !0,
                template: `#app, #main-content, body {
  --v-button-background-color: #6644FF !important;
  --v-button-background-color-hover: #5E41EC !important;
}
`
            },
            width: "full",
            group: "theming_group"
        },
        {
            field: "modules_divider",
            interface: "presentation-divider",
            options: {
                icon: "menu_open",
                title: "$t:modules"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "module_bar",
            interface: "system-modules",
            special: [
                "cast-json"
            ]
        },
        {
            field: "security_divider",
            interface: "presentation-divider",
            options: {
                icon: "shield",
                title: "$t:security"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "auth_password_policy",
            interface: "select-dropdown",
            options: {
                choices: [
                    {
                        value: null,
                        text: "$t:field_options.directus_settings.auth_password_policy.none_text"
                    },
                    {
                        value: "/^.{8,}$/",
                        text: "$t:field_options.directus_settings.auth_password_policy.weak_text"
                    },
                    {
                        value: "/(?=^.{8,}$)(?=.*\\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+}{';'?>.<,])(?!.*\\s).*$/",
                        text: "$t:field_options.directus_settings.auth_password_policy.strong_text"
                    }
                ],
                allowOther: !0
            },
            width: "half"
        },
        {
            field: "auth_login_attempts",
            interface: "input",
            options: {
                iconRight: "lock",
                placeholder: "$t:unlimited"
            },
            width: "half"
        },
        {
            field: "public_registration_divider",
            interface: "presentation-divider",
            options: {
                icon: "person_add",
                title: "$t:fields.directus_settings.public_registration"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "public_registration",
            interface: "boolean",
            note: "$t:fields.directus_settings.public_registration_note",
            width: "half",
            options: {
                label: "$t:enabled"
            },
            special: [
                "cast-boolean"
            ]
        },
        {
            field: "public_registration_role",
            interface: "select-dropdown-m2o",
            note: "$t:fields.directus_settings.public_registration_role_note",
            options: {
                template: "{{ name }}",
                filter: {
                    admin_access: {
                        _eq: !1
                    }
                }
            },
            special: [
                "m2o"
            ],
            width: "half",
            display: "related-values",
            display_options: {
                template: "{{ name }}"
            }
        },
        {
            field: "public_registration_verify_email",
            interface: "boolean",
            note: "$t:fields.directus_settings.public_registration_verify_email_note",
            width: "half",
            options: {
                label: "$t:enabled"
            },
            special: [
                "cast-boolean"
            ]
        },
        {
            field: "public_registration_email_filter",
            interface: "system-filter",
            note: "$t:fields.directus_settings.public_registration_email_filter_note",
            options: {
                collectionName: "directus_users",
                collectionField: "email",
                fieldName: "email"
            },
            special: [
                "cast-json"
            ],
            width: "half"
        },
        {
            field: "files_divider",
            interface: "presentation-divider",
            options: {
                icon: "folder",
                title: "$t:fields.directus_settings.files_and_thumbnails"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "storage_asset_transform",
            interface: "select-dropdown",
            options: {
                choices: [
                    {
                        value: "all",
                        text: "$t:fields.directus_settings.transformations_all"
                    },
                    {
                        value: "none",
                        text: "$t:fields.directus_settings.transformations_none"
                    },
                    {
                        value: "presets",
                        text: "$t:fields.directus_settings.transformations_presets"
                    }
                ]
            },
            width: "half"
        },
        {
            field: "storage_default_folder",
            interface: "system-folder",
            width: "half",
            note: "$t:interfaces.system-folder.field_hint"
        },
        {
            field: "storage_asset_presets",
            interface: "list",
            options: {
                fields: [
                    {
                        field: "key",
                        name: "$t:key",
                        type: "string",
                        schema: {
                            is_nullable: !1
                        },
                        meta: {
                            interface: "input",
                            options: {
                                slug: !0,
                                onlyOnCreate: !1
                            },
                            width: "full",
                            required: !0
                        }
                    },
                    {
                        field: "fit",
                        name: "$t:field_options.directus_settings.storage_asset_presets.fit_label",
                        type: "string",
                        schema: {
                            is_nullable: !1
                        },
                        meta: {
                            interface: "select-dropdown",
                            options: {
                                choices: [
                                    {
                                        value: "contain",
                                        text: "$t:field_options.directus_settings.storage_asset_presets.fit.contain_text"
                                    },
                                    {
                                        value: "cover",
                                        text: "$t:field_options.directus_settings.storage_asset_presets.fit.cover_text"
                                    },
                                    {
                                        value: "inside",
                                        text: "$t:field_options.directus_settings.storage_asset_presets.fit.fit_text"
                                    },
                                    {
                                        value: "outside",
                                        text: "$t:field_options.directus_settings.storage_asset_presets.fit.outside_text"
                                    }
                                ]
                            },
                            width: "half"
                        }
                    },
                    {
                        field: "width",
                        name: "$t:width",
                        type: "integer",
                        schema: {
                            is_nullable: !1
                        },
                        meta: {
                            interface: "input",
                            width: "half"
                        }
                    },
                    {
                        field: "height",
                        name: "$t:height",
                        type: "integer",
                        schema: {
                            is_nullable: !1
                        },
                        meta: {
                            interface: "input",
                            width: "half"
                        }
                    },
                    {
                        field: "quality",
                        type: "integer",
                        name: "$t:quality",
                        schema: {
                            default_value: 80,
                            is_nullable: !1
                        },
                        meta: {
                            interface: "slider",
                            options: {
                                max: 100,
                                min: 0,
                                step: 1
                            },
                            width: "half"
                        }
                    },
                    {
                        field: "withoutEnlargement",
                        name: "$t:field_options.directus_settings.storage_asset_presets.upscaling",
                        type: "boolean",
                        schema: {
                            default_value: !1
                        },
                        meta: {
                            interface: "boolean",
                            width: "half",
                            options: {
                                label: "$t:no_upscale"
                            }
                        }
                    },
                    {
                        field: "format",
                        name: "$t:format",
                        type: "string",
                        schema: {
                            is_nullable: !1,
                            default_value: ""
                        },
                        meta: {
                            interface: "select-dropdown",
                            options: {
                                allowNone: !0,
                                choices: [
                                    {
                                        value: "auto",
                                        text: "Auto"
                                    },
                                    {
                                        value: "jpeg",
                                        text: "JPEG"
                                    },
                                    {
                                        value: "png",
                                        text: "PNG"
                                    },
                                    {
                                        value: "webp",
                                        text: "WebP"
                                    },
                                    {
                                        value: "tiff",
                                        text: "Tiff"
                                    },
                                    {
                                        value: "avif",
                                        text: "AVIF"
                                    }
                                ]
                            },
                            width: "half"
                        }
                    },
                    {
                        field: "transforms",
                        name: "$t:field_options.directus_settings.additional_transforms",
                        type: "json",
                        schema: {
                            is_nullable: !1,
                            default_value: []
                        },
                        meta: {
                            note: "$t:field_options.directus_settings.transforms_note",
                            interface: "json",
                            options: {
                                template: `[
  ["blur", 45],
  ["grayscale"],
  ["extend", { "right": 500, "background": "rgb(255, 0, 0)" }]
]
`,
                                placeholder: `[
  ["blur", 45],
  ["grayscale"],
  ["extend", { "right": 500, "background": "rgb(255, 0, 0)" }]
]
`
                            },
                            width: "full"
                        }
                    }
                ],
                template: "{{key}}"
            },
            special: [
                "cast-json"
            ],
            width: "full"
        },
        {
            field: "reporting_divider",
            interface: "presentation-divider",
            options: {
                icon: "feedback",
                title: "$t:fields.directus_settings.reporting"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "report_feature_url",
            interface: "input",
            options: {
                iconRight: "link",
                placeholder: "https://example.com/feature"
            },
            width: "half"
        },
        {
            field: "report_bug_url",
            interface: "input",
            options: {
                iconRight: "link",
                placeholder: "https://example.com/bug"
            },
            width: "half"
        },
        {
            field: "report_error_url",
            interface: "system-display-template",
            options: {
                placeholder: "https://example.com/error",
                fields: [
                    {
                        name: "Error",
                        field: "error",
                        key: "error",
                        path: "error",
                        children: [
                            {
                                name: "Name",
                                field: "name",
                                key: "error.name",
                                path: "error.name"
                            },
                            {
                                name: "Message",
                                field: "message",
                                key: "error.message",
                                path: "error.message"
                            }
                        ]
                    },
                    {
                        name: "Navigator",
                        field: "navigator",
                        key: "navigator",
                        path: "navigator",
                        children: [
                            {
                                name: "Language",
                                field: "language",
                                key: "navigator.language",
                                path: "navigator.language"
                            },
                            {
                                name: "User Agent",
                                field: "userAgent",
                                key: "navigator.userAgent",
                                path: "navigator.userAgent"
                            }
                        ]
                    },
                    {
                        name: "Route",
                        field: "route",
                        key: "route",
                        path: "route",
                        children: [
                            {
                                name: "Full Path",
                                field: "fullPath",
                                key: "route.fullPath",
                                path: "route.fullPath"
                            },
                            {
                                name: "Hash",
                                field: "hash",
                                key: "route.hash",
                                path: "route.hash"
                            },
                            {
                                name: "Name",
                                field: "name",
                                key: "route.name",
                                path: "route.name"
                            },
                            {
                                name: "Path",
                                field: "path",
                                key: "route.path",
                                path: "route.path"
                            },
                            {
                                name: "Query",
                                field: "query",
                                key: "route.query",
                                path: "route.query"
                            }
                        ]
                    },
                    {
                        name: "User",
                        field: "user",
                        key: "user",
                        path: "user",
                        children: [
                            {
                                name: "ID",
                                field: "id",
                                key: "user.id",
                                path: "user.id"
                            },
                            {
                                name: "First Name",
                                field: "first_name",
                                key: "user.first_name",
                                path: "user.first_name"
                            },
                            {
                                name: "Last Name",
                                field: "last_name",
                                key: "user.last_name",
                                path: "user.last_name"
                            },
                            {
                                name: "Status",
                                field: "status",
                                key: "user.status",
                                path: "user.status"
                            },
                            {
                                name: "Title",
                                field: "title",
                                key: "user.title",
                                path: "user.title"
                            },
                            {
                                name: "Description",
                                field: "description",
                                key: "user.description",
                                path: "user.description"
                            },
                            {
                                name: "Location",
                                field: "location",
                                key: "user.location",
                                path: "user.location"
                            }
                        ]
                    },
                    {
                        name: "Role",
                        field: "role",
                        key: "role",
                        path: "role",
                        children: [
                            {
                                name: "ID",
                                field: "id",
                                key: "role.id",
                                path: "role.id"
                            },
                            {
                                name: "Name",
                                field: "name",
                                key: "role.name",
                                path: "role.name"
                            }
                        ]
                    }
                ]
            },
            width: "full"
        },
        {
            field: "map_divider",
            interface: "presentation-divider",
            options: {
                icon: "map",
                title: "$t:fields.directus_settings.mapping"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "mapbox_key",
            interface: "input",
            options: {
                icon: "key",
                title: "$t:field_options.directus_settings.mapbox_key",
                placeholder: "$t:field_options.directus_settings.mapbox_placeholder",
                iconLeft: "vpn_key",
                font: "monospace"
            },
            width: "full"
        },
        {
            field: "basemaps",
            interface: "list",
            special: [
                "cast-json"
            ],
            options: {
                template: "{{name}}",
                fields: [
                    {
                        field: "name",
                        name: "$t:name",
                        schema: {
                            is_nullable: !1
                        },
                        meta: {
                            interface: "text-input",
                            required: !0,
                            options: {
                                placeholder: "$t:field_options.directus_settings.basemaps_name_placeholder"
                            }
                        }
                    },
                    {
                        field: "type",
                        name: "$t:type",
                        meta: {
                            interface: "select-dropdown",
                            options: {
                                choices: [
                                    {
                                        value: "raster",
                                        text: "$t:field_options.directus_settings.basemaps_raster"
                                    },
                                    {
                                        value: "tile",
                                        text: "$t:field_options.directus_settings.basemaps_tile"
                                    },
                                    {
                                        value: "style",
                                        text: "$t:field_options.directus_settings.basemaps_style"
                                    }
                                ]
                            }
                        }
                    },
                    {
                        field: "url",
                        name: "$t:url",
                        schema: {
                            is_nullable: !1
                        },
                        meta: {
                            interface: "text-input",
                            options: {
                                placeholder: "http://{a-c}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                            }
                        }
                    },
                    {
                        field: "tileSize",
                        name: "$t:tile_size",
                        type: "integer",
                        schema: {
                            is_nullable: !0
                        },
                        meta: {
                            interface: "input",
                            options: {
                                placeholder: "512"
                            },
                            conditions: [
                                {
                                    name: "typeNeqRaster",
                                    rule: {
                                        type: {
                                            _neq: "raster"
                                        }
                                    },
                                    hidden: !0
                                }
                            ]
                        }
                    },
                    {
                        field: "attribution",
                        name: "$t:fields.directus_settings.attribution",
                        type: "string",
                        schema: {
                            is_nullable: !0
                        },
                        meta: {
                            interface: "input",
                            options: {
                                placeholder: "$t:fields.directus_settings.attribution_placeholder"
                            }
                        }
                    }
                ]
            }
        },
        {
            field: "image_editor",
            interface: "presentation-divider",
            options: {
                icon: "image",
                title: "$t:fields.directus_settings.image_editor"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "custom_aspect_ratios",
            interface: "list",
            special: [
                "cast-json"
            ],
            options: {
                template: "{{text}}",
                fields: [
                    {
                        field: "text",
                        name: "$t:text",
                        type: "string",
                        meta: {
                            interface: "text-input",
                            width: "half",
                            required: !0,
                            options: {
                                placeholder: "$t:text"
                            }
                        }
                    },
                    {
                        field: "value",
                        name: "$t:value",
                        type: "float",
                        meta: {
                            interface: "input",
                            width: "half",
                            required: !0,
                            options: {
                                placeholder: "$t:value"
                            }
                        }
                    }
                ]
            }
        }
    ]
};
var $dcd4e94b4ab65c1f$var$y = {
    table: "directus_users",
    fields: [
        {
            field: "first_name",
            interface: "input",
            options: {
                iconRight: "account_circle"
            },
            width: "half"
        },
        {
            field: "last_name",
            interface: "input",
            options: {
                iconRight: "account_circle"
            },
            width: "half"
        },
        {
            field: "email",
            interface: "input",
            options: {
                iconRight: "email"
            },
            width: "half"
        },
        {
            field: "password",
            special: [
                "hash",
                "conceal"
            ],
            interface: "input-hash",
            options: {
                iconRight: "lock",
                masked: !0
            },
            width: "half"
        },
        {
            field: "avatar",
            interface: "file",
            width: "full",
            display: "image"
        },
        {
            field: "location",
            interface: "input",
            options: {
                iconRight: "place"
            },
            width: "half"
        },
        {
            field: "title",
            interface: "input",
            options: {
                iconRight: "work"
            },
            width: "half"
        },
        {
            field: "description",
            interface: "input-multiline",
            width: "full"
        },
        {
            field: "tags",
            interface: "tags",
            special: [
                "cast-json"
            ],
            width: "full",
            options: {
                iconRight: "local_offer"
            },
            display: "labels",
            display_options: {
                choices: null,
                format: !1
            }
        },
        {
            field: "preferences_divider",
            interface: "presentation-divider",
            options: {
                icon: "face",
                title: "$t:fields.directus_users.user_preferences"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "language",
            interface: "system-language",
            width: "half",
            options: {
                includeProjectDefault: !0
            }
        },
        {
            field: "tfa_secret",
            interface: "system-mfa-setup",
            special: [
                "conceal"
            ],
            width: "half"
        },
        {
            field: "email_notifications",
            interface: "boolean",
            width: "half",
            special: [
                "cast-boolean"
            ]
        },
        {
            field: "theming_divider",
            interface: "presentation-divider",
            options: {
                icon: "palette",
                title: "$t:theme"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "appearance",
            interface: "select-dropdown",
            options: {
                choices: [
                    {
                        value: null,
                        text: "$t:default_sync_with_project"
                    },
                    {
                        value: "auto",
                        text: "$t:appearance_auto"
                    },
                    {
                        value: "light",
                        text: "$t:appearance_light"
                    },
                    {
                        value: "dark",
                        text: "$t:appearance_dark"
                    }
                ]
            },
            width: "half"
        },
        {
            field: "theme_light",
            width: "full",
            interface: "system-theme",
            options: {
                appearance: "light",
                includeNull: !0
            }
        },
        {
            field: "theme_light_overrides",
            width: "full",
            interface: "system-theme-overrides",
            options: {
                appearance: "light"
            },
            special: [
                "cast-json"
            ]
        },
        {
            field: "theme_dark",
            width: "full",
            interface: "system-theme",
            options: {
                appearance: "dark",
                includeNull: !0
            }
        },
        {
            field: "theme_dark_overrides",
            width: "full",
            interface: "system-theme-overrides",
            options: {
                appearance: "dark"
            },
            special: [
                "cast-json"
            ]
        },
        {
            field: "admin_divider",
            interface: "presentation-divider",
            options: {
                icon: "verified_user",
                title: "$t:fields.directus_users.admin_options",
                color: "var(--theme--danger)"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "status",
            interface: "select-dropdown",
            options: {
                choices: [
                    {
                        text: "$t:fields.directus_users.status_draft",
                        value: "draft"
                    },
                    {
                        text: "$t:fields.directus_users.status_invited",
                        value: "invited"
                    },
                    {
                        text: "$t:fields.directus_users.status_unverified",
                        value: "unverified"
                    },
                    {
                        text: "$t:fields.directus_users.status_active",
                        value: "active"
                    },
                    {
                        text: "$t:fields.directus_users.status_suspended",
                        value: "suspended"
                    },
                    {
                        text: "$t:fields.directus_users.status_archived",
                        value: "archived"
                    }
                ]
            },
            width: "half"
        },
        {
            field: "role",
            interface: "select-dropdown-m2o",
            options: {
                template: "{{ name }}"
            },
            special: [
                "m2o"
            ],
            width: "half",
            display: "related-values",
            display_options: {
                template: "{{ name }}"
            }
        },
        {
            field: "token",
            interface: "system-token",
            special: [
                "conceal"
            ],
            width: "full"
        },
        {
            field: "id",
            special: [
                "uuid"
            ],
            interface: "input",
            options: {
                iconRight: "vpn_key"
            },
            width: "full"
        },
        {
            field: "last_page",
            width: "half"
        },
        {
            field: "last_access",
            width: "half",
            display: "datetime",
            readonly: !0,
            display_options: {
                relative: !0
            }
        },
        {
            field: "provider",
            width: "half",
            interface: "select-dropdown",
            options: {
                choices: [
                    {
                        text: "$t:default_provider",
                        value: "default"
                    }
                ]
            }
        },
        {
            field: "external_identifier",
            width: "half",
            options: {
                iconRight: "account_circle"
            },
            interface: "input"
        },
        {
            field: "auth_data",
            hidden: !0
        }
    ]
};
var $dcd4e94b4ab65c1f$var$w = {
    table: "directus_webhooks",
    fields: [
        {
            field: "id",
            hidden: !0
        },
        {
            field: "name",
            interface: "input",
            options: {
                iconRight: "title"
            },
            width: "full"
        },
        {
            field: "method",
            interface: "select-dropdown",
            display: "labels",
            display_options: {
                choices: [
                    {
                        value: "POST",
                        foreground: "var(--theme--primary)",
                        background: "var(--theme--primary-subdued)"
                    },
                    {
                        value: "GET",
                        foreground: "var(--theme--secondary)",
                        background: "var(--secondary-25)"
                    }
                ],
                format: !1
            },
            options: {
                choices: [
                    "GET",
                    "POST"
                ]
            },
            width: "half"
        },
        {
            field: "url",
            interface: "input",
            options: {
                iconRight: "link"
            },
            width: "half"
        },
        {
            field: "status",
            interface: "select-dropdown",
            display: "labels",
            display_options: {
                showAsDot: !0,
                choices: [
                    {
                        text: "$t:field_options.directus_webhooks.status_options_active",
                        value: "active",
                        foreground: "var(--theme--primary-background)",
                        background: "var(--theme--primary)"
                    },
                    {
                        text: "$t:field_options.directus_webhooks.status_options_inactive",
                        value: "inactive",
                        foreground: "var(--theme--foreground)",
                        background: "var(--background-normal-alt)"
                    }
                ]
            },
            options: {
                choices: [
                    {
                        text: "$t:field_options.directus_webhooks.status_options_active",
                        value: "active"
                    },
                    {
                        text: "$t:field_options.directus_webhooks.status_options_inactive",
                        value: "inactive"
                    }
                ]
            },
            width: "half"
        },
        {
            field: "data",
            interface: "boolean",
            options: {
                label: "$t:fields.directus_webhooks.data_label"
            },
            special: [
                "cast-boolean"
            ],
            width: "half",
            display: "boolean"
        },
        {
            field: "headers",
            special: [
                "cast-json"
            ],
            interface: "list",
            options: {
                template: "{{ header }}: {{ value }}",
                addLabel: "$t:field_options.directus_webhooks.headers.add",
                fields: [
                    {
                        field: "header",
                        name: "$t:field_options.directus_webhooks.headers.header",
                        type: "string",
                        meta: {
                            interface: "input",
                            width: "half"
                        }
                    },
                    {
                        field: "value",
                        name: "$t:field_options.directus_webhooks.headers.value",
                        type: "string",
                        meta: {
                            interface: "input",
                            width: "half"
                        }
                    }
                ]
            },
            width: "full"
        },
        {
            field: "triggers_divider",
            interface: "presentation-divider",
            options: {
                icon: "api",
                title: "$t:fields.directus_webhooks.triggers"
            },
            special: [
                "alias",
                "no-data"
            ],
            width: "full"
        },
        {
            field: "actions",
            interface: "select-multiple-checkbox",
            options: {
                choices: [
                    {
                        text: "$t:create",
                        value: "create"
                    },
                    {
                        text: "$t:update",
                        value: "update"
                    },
                    {
                        text: "$t:delete_label",
                        value: "delete"
                    }
                ]
            },
            special: [
                "cast-csv"
            ],
            width: "full",
            display: "labels",
            display_options: {
                choices: [
                    {
                        text: "$t:create",
                        value: "create",
                        foreground: "var(--theme--primary)",
                        background: "var(--theme--primary-subdued)"
                    },
                    {
                        text: "$t:update",
                        value: "update",
                        foreground: "var(--blue)",
                        background: "var(--blue-25)"
                    },
                    {
                        text: "$t:delete_label",
                        value: "delete",
                        foreground: "var(--theme--danger)",
                        background: "var(--danger-25)"
                    },
                    {
                        text: "$t:login",
                        value: "login",
                        foreground: "var(--purple)",
                        background: "var(--purple-25)"
                    }
                ]
            }
        },
        {
            field: "collections",
            interface: "system-collections",
            special: [
                "cast-csv"
            ],
            width: "full",
            display: "labels",
            display_options: {
                choices: null,
                format: !1
            }
        },
        {
            field: "was_active_before_deprecation",
            hidden: !0
        },
        {
            field: "migrated_flow",
            hidden: !0
        }
    ]
};
var $dcd4e94b4ab65c1f$var$v = {
    table: "directus_dashboards",
    fields: [
        {
            field: "id",
            special: [
                "uuid"
            ]
        },
        {
            field: "name"
        },
        {
            field: "icon"
        },
        {
            field: "panels",
            special: [
                "o2m"
            ]
        },
        {
            field: "date_created",
            special: [
                "date-created",
                "cast-timestamp"
            ]
        },
        {
            field: "user_created",
            special: [
                "user-created"
            ]
        },
        {
            field: "note"
        },
        {
            field: "color"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$b = {
    table: "directus_panels",
    fields: [
        {
            field: "id",
            special: [
                "uuid"
            ]
        },
        {
            field: "name"
        },
        {
            field: "icon"
        },
        {
            field: "color"
        },
        {
            field: "note"
        },
        {
            field: "type"
        },
        {
            field: "show_header",
            special: [
                "cast-boolean"
            ]
        },
        {
            field: "position_x"
        },
        {
            field: "position_y"
        },
        {
            field: "width"
        },
        {
            field: "height"
        },
        {
            field: "options",
            special: [
                "cast-json"
            ]
        },
        {
            field: "date_created",
            special: [
                "date-created",
                "cast-timestamp"
            ]
        },
        {
            field: "user_created",
            special: [
                "user-created"
            ]
        },
        {
            field: "dashboard"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$$ = {
    table: "directus_notifications",
    fields: [
        {
            field: "id"
        },
        {
            field: "timestamp",
            special: [
                "date-created",
                "cast-timestamp"
            ]
        },
        {
            field: "status"
        },
        {
            field: "recipient"
        },
        {
            field: "sender"
        },
        {
            field: "subject"
        },
        {
            field: "message"
        },
        {
            field: "collection"
        },
        {
            field: "item"
        }
    ]
};
var $dcd4e94b4ab65c1f$var$k = {
    table: "directus_shares",
    fields: [
        {
            field: "id",
            special: [
                "uuid"
            ],
            readonly: !0,
            hidden: !0
        },
        {
            field: "name"
        },
        {
            field: "collection",
            width: "half",
            hidden: !0
        },
        {
            field: "item",
            width: "half",
            hidden: !0
        },
        {
            field: "role",
            interface: "select-dropdown-m2o",
            width: "half",
            options: {
                template: "{{name}}",
                filter: {
                    admin_access: {
                        _eq: !1
                    }
                }
            }
        },
        {
            field: "password",
            special: [
                "hash",
                "conceal"
            ],
            interface: "input-hash",
            options: {
                iconRight: "lock",
                masked: !0
            },
            width: "half",
            note: "$t:shared_leave_blank_for_passwordless_access"
        },
        {
            field: "date_start",
            width: "half",
            note: "$t:shared_leave_blank_for_unlimited"
        },
        {
            field: "date_end",
            width: "half",
            note: "$t:shared_leave_blank_for_unlimited"
        },
        {
            field: "max_uses",
            width: "half",
            note: "$t:shared_leave_blank_for_unlimited"
        },
        {
            field: "times_used",
            width: "half",
            readonly: !0
        },
        {
            field: "date_created",
            special: [
                "date-created",
                "cast-timestamp"
            ],
            width: "half",
            readonly: !0,
            conditions: [
                {
                    name: "notCreatedYet",
                    rule: {
                        id: {
                            _null: !0
                        }
                    },
                    hidden: !0
                }
            ]
        },
        {
            field: "user_created",
            special: [
                "user-created"
            ],
            interface: "select-dropdown-m2o",
            width: "half",
            display: "user",
            options: {
                template: "{{avatar.$thumbnail}} {{first_name}} {{last_name}}"
            },
            readonly: !0,
            conditions: [
                {
                    name: "notCreatedYet",
                    rule: {
                        id: {
                            _null: !0
                        }
                    },
                    hidden: !0
                }
            ]
        }
    ]
};
var $dcd4e94b4ab65c1f$var$x = {
    table: "directus_flows",
    fields: [
        {
            field: "id",
            special: [
                "uuid"
            ]
        },
        {
            field: "name"
        },
        {
            field: "icon"
        },
        {
            field: "color"
        },
        {
            field: "description"
        },
        {
            field: "status"
        },
        {
            field: "trigger"
        },
        {
            field: "accountability"
        },
        {
            field: "options",
            special: [
                "cast-json"
            ]
        },
        {
            field: "operation"
        },
        {
            field: "operations",
            special: [
                "o2m"
            ]
        },
        {
            field: "date_created",
            special: [
                "date-created"
            ]
        },
        {
            field: "user_created",
            special: [
                "user-created"
            ]
        }
    ]
};
var $dcd4e94b4ab65c1f$var$R = {
    table: "directus_operations",
    fields: [
        {
            field: "id",
            special: [
                "uuid"
            ]
        },
        {
            field: "name"
        },
        {
            field: "key"
        },
        {
            field: "type"
        },
        {
            field: "position_x"
        },
        {
            field: "position_y"
        },
        {
            field: "options",
            special: [
                "cast-json"
            ]
        },
        {
            field: "resolve"
        },
        {
            field: "reject"
        },
        {
            field: "flow"
        },
        {
            field: "date_created",
            special: [
                "date-created"
            ]
        },
        {
            field: "user_created",
            special: [
                "user-created"
            ]
        }
    ]
};
var $dcd4e94b4ab65c1f$var$j = {
    table: "directus_translations",
    fields: [
        {
            field: "id",
            hidden: !0,
            sort: 1,
            special: [
                "uuid"
            ]
        },
        {
            field: "key",
            width: "half",
            sort: 2,
            required: !0,
            interface: "input",
            options: {
                font: "monospace",
                placeholder: "$t:translation_key_placeholder"
            }
        },
        {
            field: "language",
            interface: "system-language",
            width: "half",
            sort: 3,
            required: !0
        },
        {
            field: "value",
            interface: "input-multiline",
            sort: 4,
            required: !0,
            options: {
                placeholder: "$t:enter_a_value"
            }
        }
    ]
};
var $dcd4e94b4ab65c1f$var$F = {
    table: "directus_versions",
    fields: [
        {
            field: "id",
            special: [
                "uuid"
            ],
            readonly: !0,
            hidden: !0
        },
        {
            field: "key"
        },
        {
            field: "name"
        },
        {
            field: "collection"
        },
        {
            field: "item"
        },
        {
            field: "hash",
            readonly: !0,
            hidden: !0
        },
        {
            field: "date_created",
            special: [
                "date-created",
                "cast-timestamp"
            ]
        },
        {
            field: "date_updated",
            special: [
                "date-updated",
                "cast-timestamp"
            ]
        },
        {
            field: "user_created",
            special: [
                "user-created"
            ]
        },
        {
            field: "user_updated",
            special: [
                "user-updated"
            ]
        }
    ]
};
var $dcd4e94b4ab65c1f$var$q = {
    table: "directus_extensions",
    fields: [
        {
            collection: "directus_extensions",
            field: "id",
            special: [
                "uuid"
            ]
        },
        {
            collection: "directus_extensions",
            field: "folder"
        },
        {
            collection: "directus_extensions",
            field: "source"
        },
        {
            collection: "directus_extensions",
            field: "bundle"
        },
        {
            collection: "directus_extensions",
            field: "enabled",
            special: [
                "cast-boolean"
            ]
        }
    ]
};
var $dcd4e94b4ab65c1f$export$7f42814d74ced2e3 = [];
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$a);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$s);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$n);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$d);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$r);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$c);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$f);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$u);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$p);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$_);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$h);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$m);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$g);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$y);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$w);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$v);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$b);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$$);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$k);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$x);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$R);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$j);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$F);
$dcd4e94b4ab65c1f$var$e($dcd4e94b4ab65c1f$var$q);
function $dcd4e94b4ab65c1f$var$e(i) {
    let { fields: P, table: U } = i;
    P.forEach((T, S)=>{
        $dcd4e94b4ab65c1f$export$7f42814d74ced2e3.push({
            system: !0,
            ...$dcd4e94b4ab65c1f$var$o,
            ...T,
            collection: U,
            sort: S + 1
        });
    });
}
var $dcd4e94b4ab65c1f$var$E = [
    {
        collection: "directus_collections",
        action: "read"
    },
    {
        collection: "directus_fields",
        action: "read"
    },
    {
        collection: "directus_permissions",
        action: "read",
        permissions: {
            role: {
                _eq: "$CURRENT_ROLE"
            }
        }
    },
    {
        collection: "directus_relations",
        action: "read"
    }
];
var $dcd4e94b4ab65c1f$var$N = [
    {
        collection: "directus_activity",
        action: "read",
        permissions: {
            user: {
                _eq: "$CURRENT_USER"
            }
        }
    },
    {
        collection: "directus_activity",
        action: "create",
        validation: {
            comment: {
                _nnull: !0
            }
        }
    },
    {
        collection: "directus_presets",
        action: "read",
        permissions: {
            _or: [
                {
                    user: {
                        _eq: "$CURRENT_USER"
                    }
                },
                {
                    _and: [
                        {
                            user: {
                                _null: !0
                            }
                        },
                        {
                            role: {
                                _eq: "$CURRENT_ROLE"
                            }
                        }
                    ]
                },
                {
                    _and: [
                        {
                            user: {
                                _null: !0
                            }
                        },
                        {
                            role: {
                                _null: !0
                            }
                        }
                    ]
                }
            ]
        }
    },
    {
        collection: "directus_presets",
        action: "create",
        validation: {
            user: {
                _eq: "$CURRENT_USER"
            }
        }
    },
    {
        collection: "directus_presets",
        action: "update",
        permissions: {
            user: {
                _eq: "$CURRENT_USER"
            }
        }
    },
    {
        collection: "directus_presets",
        action: "delete",
        permissions: {
            user: {
                _eq: "$CURRENT_USER"
            }
        }
    },
    {
        collection: "directus_roles",
        action: "read",
        permissions: {
            id: {
                _eq: "$CURRENT_ROLE"
            }
        }
    },
    {
        collection: "directus_settings",
        action: "read"
    },
    {
        collection: "directus_translations",
        action: "read"
    },
    {
        collection: "directus_notifications",
        action: "read",
        permissions: {
            recipient: {
                _eq: "$CURRENT_USER"
            }
        }
    },
    {
        collection: "directus_notifications",
        action: "update",
        permissions: {
            recipient: {
                _eq: "$CURRENT_USER"
            }
        },
        fields: [
            "status"
        ]
    },
    {
        collection: "directus_shares",
        action: "read",
        permissions: {
            user_created: {
                _eq: "$CURRENT_USER"
            }
        }
    },
    {
        collection: "directus_users",
        action: "read",
        permissions: {
            id: {
                _eq: "$CURRENT_USER"
            }
        },
        fields: [
            "id",
            "first_name",
            "last_name",
            "last_page",
            "email",
            "password",
            "location",
            "title",
            "description",
            "tags",
            "preferences_divider",
            "avatar",
            "language",
            "appearance",
            "theme_light",
            "theme_dark",
            "tfa_secret",
            "status",
            "role"
        ]
    }
];
var $dcd4e94b4ab65c1f$var$C = {
    role: null,
    permissions: {},
    validation: null,
    presets: null,
    fields: [
        "*"
    ],
    system: !0
}, $dcd4e94b4ab65c1f$export$ff0a85fdc4c77251 = $dcd4e94b4ab65c1f$var$E.map((i)=>({
        ...$dcd4e94b4ab65c1f$var$C,
        ...i
    })), $dcd4e94b4ab65c1f$export$31ff17590d8ce78e = [
    ...$dcd4e94b4ab65c1f$export$ff0a85fdc4c77251,
    ...$dcd4e94b4ab65c1f$var$N
].map((i)=>({
        ...$dcd4e94b4ab65c1f$var$C,
        ...i
    }));


function $0a1528612dc62d8d$export$94b8006881d8c10d(e) {
    return e ? `/auth/login/${e}` : "/auth/login";
}
var $0a1528612dc62d8d$var$E = "/", $0a1528612dc62d8d$var$G = (e, t)=>(e.endsWith($0a1528612dc62d8d$var$E) && (e = e.slice(0, -1)), t.startsWith($0a1528612dc62d8d$var$E) || (t = $0a1528612dc62d8d$var$E + t), e + t), $0a1528612dc62d8d$var$b = (e, t, r)=>{
    let s = e.pathname === $0a1528612dc62d8d$var$E ? t : $0a1528612dc62d8d$var$G(e.pathname, t), a = new globalThis.URL(s, e);
    if (r) for (let [p, i] of Object.entries($0a1528612dc62d8d$export$9f72cc599b0bf53(r)))if (i && typeof i == "object" && !Array.isArray(i)) for (let [c, y] of Object.entries(i))a.searchParams.set(`${p}[${c}]`, String(y));
    else a.searchParams.set(p, i);
    return a;
};
function $0a1528612dc62d8d$var$U(e) {
    return typeof e != "object" || !e ? !1 : "headers" in e && "ok" in e && "json" in e && typeof e.json == "function" && "text" in e && typeof e.json == "function";
}
async function $0a1528612dc62d8d$var$J(e) {
    if (!(typeof e != "object" || !e)) {
        if ($0a1528612dc62d8d$var$U(e)) {
            let t = e.headers.get("Content-Type")?.toLowerCase();
            if (t?.startsWith("application/json") || t?.startsWith("application/health+json")) {
                let r = await e.json();
                if (!e.ok) throw r;
                return "data" in r ? r.data : r;
            }
            if (t?.startsWith("text/html") || t?.startsWith("text/plain")) {
                let r = await e.text();
                if (!e.ok) throw r;
                return r;
            }
            return e;
        }
        return "data" in e ? e.data : e;
    }
}
var $0a1528612dc62d8d$var$D = async (e, t, r = globalThis.fetch)=>(t.headers = typeof t.headers == "object" && !Array.isArray(t.headers) ? t.headers : {}, r(e, t).then((s)=>$0a1528612dc62d8d$var$J(s).catch((a)=>{
            let p = typeof a == "object" && "errors" in a ? a.errors : a;
            return Promise.reject({
                errors: p,
                response: s
            });
        })));
var $0a1528612dc62d8d$export$28db2db1ba45b8f6 = ()=>{
    let e = null;
    return {
        get: async ()=>e,
        set: async (t)=>{
            e = t;
        }
    };
};
var $0a1528612dc62d8d$var$L = {
    msRefreshBeforeExpires: 3e4,
    autoRefresh: !0
}, $0a1528612dc62d8d$var$H = 2 ** 31 - 1, $0a1528612dc62d8d$export$8bf4ce924aca1720 = (e = "cookie", t = {})=>(r)=>{
        let s = {
            ...$0a1528612dc62d8d$var$L,
            ...t
        }, a = null, p = null, i = s.storage ?? $0a1528612dc62d8d$export$28db2db1ba45b8f6(), c = ()=>{
            i.set({
                access_token: null,
                refresh_token: null,
                expires: null,
                expires_at: null
            });
        }, y = async ()=>{
            try {
                await a;
            } finally{
                a = null;
            }
        }, x = async ()=>{
            let d = await i.get();
            return a || !d?.expires_at || d.expires_at < new Date().getTime() + s.msRefreshBeforeExpires && T().catch((l)=>{}), y();
        }, O = (d)=>{
            let l = d.expires ?? 0;
            d.expires_at = new Date().getTime() + l, i.set(d), s.autoRefresh && l > s.msRefreshBeforeExpires && l < $0a1528612dc62d8d$var$H && (p && clearTimeout(p), p = setTimeout(()=>{
                p = null, T().catch((f)=>{});
            }, l - s.msRefreshBeforeExpires));
        }, T = async ()=>(a = (async ()=>{
                let l = await i.get();
                c();
                let f = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                };
                "credentials" in s && (f.credentials = s.credentials);
                let m = {
                    mode: e
                };
                e === "json" && l?.refresh_token && (m.refresh_token = l.refresh_token), f.body = JSON.stringify(m);
                let n = $0a1528612dc62d8d$var$b(r.url, "/auth/refresh");
                return $0a1528612dc62d8d$var$D(n.toString(), f, r.globals.fetch).then((u)=>(O(u), u));
            })(), a);
        return {
            refresh: T,
            async login (d, l, f = {}) {
                c();
                let m = {
                    email: d,
                    password: l
                };
                "otp" in f && (m.otp = f.otp), m.mode = f.mode ?? e;
                let n = $0a1528612dc62d8d$export$94b8006881d8c10d(f.provider), u = $0a1528612dc62d8d$var$b(r.url, n), h = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(m)
                };
                "credentials" in s && (h.credentials = s.credentials);
                let g = await $0a1528612dc62d8d$var$D(u.toString(), h, r.globals.fetch);
                return O(g), g;
            },
            async logout () {
                let d = await i.get(), l = {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    }
                };
                "credentials" in s && (l.credentials = s.credentials);
                let f = {
                    mode: e
                };
                e === "json" && d?.refresh_token && (f.refresh_token = d.refresh_token), l.body = JSON.stringify(f);
                let m = $0a1528612dc62d8d$var$b(r.url, "/auth/logout");
                await $0a1528612dc62d8d$var$D(m.toString(), l, r.globals.fetch), this.stopRefreshing(), c();
            },
            stopRefreshing () {
                p && clearTimeout(p);
            },
            async getToken () {
                return await x().catch(()=>{}), (await i.get())?.access_token ?? null;
            },
            setToken (d) {
                i.set({
                    access_token: d,
                    refresh_token: null,
                    expires: null,
                    expires_at: null
                });
            }
        };
    };
var $0a1528612dc62d8d$export$d4ac380365815345 = (e)=>(t)=>{
        let r = e ?? null;
        return {
            async getToken () {
                return r;
            },
            setToken (s) {
                r = s;
            }
        };
    };
var $0a1528612dc62d8d$var$k = {
    fetch: globalThis.fetch,
    WebSocket: globalThis.WebSocket,
    URL: globalThis.URL,
    logger: globalThis.console
}, $0a1528612dc62d8d$export$63427ba69af216fe = (e, t = {})=>{
    let r = t.globals ? {
        ...$0a1528612dc62d8d$var$k,
        ...t.globals
    } : $0a1528612dc62d8d$var$k;
    return {
        globals: r,
        url: new r.URL(e),
        with (s) {
            return {
                ...this,
                ...s(this)
            };
        }
    };
};
var $0a1528612dc62d8d$var$V = {}, $0a1528612dc62d8d$export$1eb4e7c0ed67b035 = (e = {})=>(t)=>{
        let r = {
            ...$0a1528612dc62d8d$var$V,
            ...e
        };
        return {
            async query (s, a, p = "items") {
                let i = {
                    method: "POST",
                    body: JSON.stringify({
                        query: s,
                        variables: a
                    })
                };
                "credentials" in r && (i.credentials = r.credentials);
                let c = {};
                if ("getToken" in this) {
                    let O = await this.getToken();
                    O && (c.Authorization = `Bearer ${O}`);
                }
                "Content-Type" in c || (c["Content-Type"] = "application/json"), i.headers = c;
                let y = p === "items" ? "/graphql" : "/graphql/system", x = $0a1528612dc62d8d$var$b(t.url, y);
                return await $0a1528612dc62d8d$var$D(x.toString(), i, t.globals.fetch);
            }
        };
    };
function $0a1528612dc62d8d$export$73693bad9f5880b0(e) {
    return JSON.stringify({
        ...e,
        type: "auth"
    });
}
var $0a1528612dc62d8d$export$dffc9798653bfd52 = ()=>JSON.stringify({
        type: "pong"
    });
var $0a1528612dc62d8d$export$2c0e87021c82e6a0 = (e, t = 1e3)=>new Promise((r, s)=>{
        let a = (y)=>{
            try {
                let x = JSON.parse(y.data);
                typeof x == "object" && !Array.isArray(x) && x !== null ? (i(), r(x)) : (i(), p());
            } catch  {
                i(), r(y);
            }
        }, p = ()=>s(), i = ()=>{
            clearTimeout(c), e.removeEventListener("message", a), e.removeEventListener("error", p), e.removeEventListener("close", p);
        };
        e.addEventListener("message", a), e.addEventListener("error", p), e.addEventListener("close", p);
        let c = setTimeout(()=>{
            i(), r(void 0);
        }, t);
    });
function* $0a1528612dc62d8d$export$b10747473b5ad61e() {
    let e = 1;
    for(;;)yield String(e), e++;
}
var $0a1528612dc62d8d$var$M = {
    authMode: "handshake",
    heartbeat: !0,
    debug: !1,
    reconnect: {
        delay: 1e3,
        retries: 10
    }
};
function $0a1528612dc62d8d$export$ea80eb855ab064f8(e = {}) {
    return (t)=>{
        e = {
            ...$0a1528612dc62d8d$var$M,
            ...e
        };
        let r = $0a1528612dc62d8d$export$b10747473b5ad61e(), s = {
            code: "closed"
        }, a = {
            attempts: 0,
            active: !1
        }, p = new Set, i = (m)=>"getToken" in m, c = (m, ...n)=>e.debug && t.globals.logger[m]("[Directus SDK]", ...n), y = async (m, n)=>{
            let u = new t.globals.URL(m);
            if (e.authMode === "strict" && i(n)) {
                let h = await n.getToken();
                h && u.searchParams.set("access_token", h);
            }
            return u.toString();
        }, x = async (m)=>{
            if ("url" in e) return await y(e.url, m);
            if ([
                "ws:",
                "wss:"
            ].includes(t.url.protocol)) return await y(t.url, m);
            let n = new t.globals.URL(t.url.toString());
            return n.protocol = t.url.protocol === "https:" ? "wss:" : "ws:", n.pathname = "/websocket", await y(n, m);
        }, O = (m)=>{
            let n = new Promise((u, h)=>{
                if (!e.reconnect) return h();
                if (c("info", `reconnect #${a.attempts} ` + (a.attempts >= e.reconnect.retries ? "maximum retries reached" : `trying again in ${Math.max(100, e.reconnect.delay)}ms`)), a.active) return a.active;
                if (a.attempts >= e.reconnect.retries) return h();
                setTimeout(()=>m.connect().then((g)=>(p.forEach((S)=>{
                            m.sendMessage(S);
                        }), g)).then(u).catch(h), Math.max(100, e.reconnect.delay));
            });
            a.attempts += 1, a.active = n.catch(()=>{}).finally(()=>{
                a.active = !1;
            });
        }, T = {
            open: new Set([]),
            error: new Set([]),
            close: new Set([]),
            message: new Set([])
        };
        function d(m) {
            return "type" in m && "status" in m && "error" in m && "code" in m.error && "message" in m.error && m.type === "auth" && m.status === "error";
        }
        async function l(m, n) {
            if (s.code === "open") {
                if (m.error.code === "TOKEN_EXPIRED" && (c("warn", "Authentication token expired!"), i(n))) {
                    let u = await n.getToken();
                    if (!u) throw Error("No token for re-authenticating the websocket");
                    s.connection.send($0a1528612dc62d8d$export$73693bad9f5880b0({
                        access_token: u
                    }));
                }
                if (m.error.code === "AUTH_TIMEOUT") return s.firstMessage && e.authMode === "public" ? (c("warn", 'Authentication failed! Currently the "authMode" is "public" try using "handshake" instead'), e.reconnect = !1) : c("warn", "Authentication timed out!"), s.connection.close();
                if (m.error.code === "AUTH_FAILED") {
                    if (s.firstMessage && e.authMode === "public") return c("warn", 'Authentication failed! Currently the "authMode" is "public" try using "handshake" instead'), e.reconnect = !1, s.connection.close();
                    c("warn", "Authentication failed!");
                }
            }
        }
        let f = async (m)=>{
            for(; s.code === "open";){
                let n = await $0a1528612dc62d8d$export$2c0e87021c82e6a0(s.connection).catch(()=>{});
                if (n) {
                    if (d(n)) {
                        await l(n, m), s.firstMessage = !1;
                        continue;
                    }
                    if (e.heartbeat && n.type === "ping") {
                        s.connection.send($0a1528612dc62d8d$export$dffc9798653bfd52()), s.firstMessage = !1;
                        continue;
                    }
                    T.message.forEach((u)=>{
                        s.code === "open" && u.call(s.connection, n);
                    }), s.firstMessage = !1;
                }
            }
        };
        return {
            async connect () {
                if (s.code === "connecting") return await s.connection;
                if (s.code !== "closed") throw new Error(`Cannot connect when state is "${s.code}"`);
                let m = this, n = await x(m);
                c("info", `Connecting to ${n}...`);
                let u = new Promise((h, g)=>{
                    let S = !1, C = new t.globals.WebSocket(n);
                    C.addEventListener("open", async (j)=>{
                        if (c("info", "Connection open."), s = {
                            code: "open",
                            connection: C,
                            firstMessage: !0
                        }, a.attempts = 0, a.active = !1, f(m), e.authMode === "handshake" && i(m)) {
                            let R = await m.getToken();
                            if (!R) throw Error("No token for authenticating the websocket. Make sure to provide one or call the login() function beforehand.");
                            C.send($0a1528612dc62d8d$export$73693bad9f5880b0({
                                access_token: R
                            }));
                            let P = await $0a1528612dc62d8d$export$2c0e87021c82e6a0(C);
                            if (P && "type" in P && "status" in P && P.type === "auth" && P.status === "ok") c("info", "Authentication successful!");
                            else return g("Authentication failed while opening websocket connection");
                        }
                        T.open.forEach((R)=>R.call(C, j)), S = !0, h(C);
                    }), C.addEventListener("error", (j)=>{
                        c("warn", "Connection errored."), T.error.forEach((R)=>R.call(C, j)), C.close(), s = {
                            code: "error"
                        }, S || g(j);
                    }), C.addEventListener("close", (j)=>{
                        c("info", "Connection closed."), T.close.forEach((R)=>R.call(C, j)), r = $0a1528612dc62d8d$export$b10747473b5ad61e(), s = {
                            code: "closed"
                        }, O(this), S || g(j);
                    });
                });
                return s = {
                    code: "connecting",
                    connection: u
                }, u;
            },
            disconnect () {
                s.code === "open" && s.connection.close();
            },
            onWebSocket (m, n) {
                if (m === "message") {
                    let u = function(h) {
                        if (typeof h.data != "string") return n.call(this, h);
                        try {
                            return n.call(this, JSON.parse(h.data));
                        } catch  {
                            return n.call(this, h);
                        }
                    };
                    return T[m].add(u), ()=>T[m].delete(u);
                }
                return T[m].add(n), ()=>T[m].delete(n);
            },
            sendMessage (m) {
                if (s.code !== "open") throw new Error('Cannot send messages without an open connection. Make sure you are calling "await client.connect()".');
                if (typeof m == "string") return s.connection.send(m);
                "uid" in m || (m.uid = r.next().value), s.connection.send(JSON.stringify(m));
            },
            async subscribe (m, n = {}) {
                "uid" in n || (n.uid = r.next().value), p.add({
                    ...n,
                    collection: m,
                    type: "subscribe"
                }), s.code !== "open" && (c("info", "No connection available for subscribing!"), await this.connect()), this.sendMessage({
                    ...n,
                    collection: m,
                    type: "subscribe"
                });
                let u = !0;
                async function* h() {
                    for(; u && s.code === "open";){
                        let S = await $0a1528612dc62d8d$export$2c0e87021c82e6a0(s.connection).catch(()=>{});
                        if (S) {
                            if ("type" in S && "status" in S && S.type === "subscribe" && S.status === "error") throw S;
                            "type" in S && "uid" in S && S.type === "subscription" && S.uid === n.uid && (yield S);
                        }
                    }
                    e.reconnect && a.active && (await a.active, s.code === "open" && (s.connection.send(JSON.stringify({
                        ...n,
                        collection: m,
                        type: "subscribe"
                    })), yield* h()));
                }
                let g = ()=>{
                    p.delete({
                        ...n,
                        collection: m,
                        type: "subscribe"
                    }), this.sendMessage({
                        uid: n.uid,
                        type: "unsubscribe"
                    }), u = !1;
                };
                return {
                    subscription: h(),
                    unsubscribe: g
                };
            }
        };
    };
}
var $0a1528612dc62d8d$export$e772c8ff12451969 = (e)=>new Promise((t)=>setTimeout(()=>t(), e));
var $0a1528612dc62d8d$export$596d806903d1f59e = (e, t, r = {})=>()=>{
        let s = $0a1528612dc62d8d$export$94b8006881d8c10d(r.provider), a = {
            email: e,
            password: t
        };
        return "otp" in r && (a.otp = r.otp), a.mode = r.mode ?? "cookie", {
            path: s,
            method: "POST",
            body: JSON.stringify(a)
        };
    };
var $0a1528612dc62d8d$export$a0973bcfe11b05c9 = (e, t = "cookie")=>()=>({
            path: "/auth/logout",
            method: "POST",
            body: JSON.stringify(e ? {
                refresh_token: e,
                mode: t
            } : {
                mode: t
            })
        });
var $0a1528612dc62d8d$export$ed100ba7dcdf87f5 = (e, t)=>()=>({
            path: "/auth/password/request",
            method: "POST",
            body: JSON.stringify({
                email: e,
                ...t ? {
                    reset_url: t
                } : {}
            })
        });
var $0a1528612dc62d8d$export$ee2fcf8e7aed6a8 = (e, t)=>()=>({
            path: "/auth/password/reset",
            method: "POST",
            body: JSON.stringify({
                token: e,
                password: t
            })
        });
var $0a1528612dc62d8d$export$c5742f7ebc1d64e7 = (e = !1)=>()=>({
            path: e ? "/auth?sessionOnly" : "/auth",
            method: "GET"
        });
var $0a1528612dc62d8d$export$2d6e9b4c68afb6c8 = (e = "cookie", t)=>()=>({
            path: "/auth/refresh",
            method: "POST",
            body: JSON.stringify(e === "json" ? {
                refresh_token: t,
                mode: e
            } : {
                mode: e
            })
        });
var $0a1528612dc62d8d$export$2a15b079e3f46654 = (e, t)=>()=>({
            path: "/activity/comment",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$c74125a8e3af6bb2 = (e, t)=>()=>({
            path: "/collections",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$7ac7101846d6f893 = (e, t)=>()=>({
            path: "/dashboards",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$eadf0ac433611b3 = (e, t)=>()=>({
            path: "/dashboards",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$17fc0a47da34544a = (e, t, r)=>()=>({
            path: `/fields/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "POST"
        });
var $0a1528612dc62d8d$export$69895bd328f2dda9 = (e, t)=>()=>({
            path: "/files",
            method: "POST",
            body: e,
            params: t ?? {},
            headers: {
                "Content-Type": "multipart/form-data"
            }
        }), $0a1528612dc62d8d$export$4da7403fdb9cb456 = (e, t = {}, r)=>()=>({
            path: "/files/import",
            method: "POST",
            body: JSON.stringify({
                url: e,
                data: t
            }),
            params: r ?? {}
        });
var $0a1528612dc62d8d$export$4400de2e7edcec7c = (e, t)=>()=>({
            path: "/flows",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$7f5b2d57e7eb4cc8 = (e, t)=>()=>({
            path: "/flows",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$d1304b216aaaddfd = (e, t)=>()=>({
            path: "/folders",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$b385cd416acc7fdd = (e, t)=>()=>({
            path: "/folders",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$af56db357559c888 = (e, t, r)=>()=>{
        let s = String(e);
        if ((0, $dcd4e94b4ab65c1f$export$f4f5d58c6b1bdc44)(s)) throw new Error("Cannot use createItems for core collections");
        return {
            path: `/items/${s}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "POST"
        };
    }, $0a1528612dc62d8d$export$1f768fd5b3313118 = (e, t, r)=>()=>{
        let s = String(e);
        if ((0, $dcd4e94b4ab65c1f$export$f4f5d58c6b1bdc44)(s)) throw new Error("Cannot use createItem for core collections");
        return {
            path: `/items/${s}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "POST"
        };
    };
var $0a1528612dc62d8d$export$9baa1bac95edf573 = (e, t)=>()=>({
            path: "/notifications",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$9c8f6e8d39c60cf3 = (e, t)=>()=>({
            path: "/notifications",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$798e5748053a0ed9 = (e, t)=>()=>({
            path: "/operations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$f29bedd62f56fcb2 = (e, t)=>()=>({
            path: "/operations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$b958d79d7d7b6f61 = (e, t)=>()=>({
            path: "/panels",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$71ce2d4d67b6d9e4 = (e, t)=>()=>({
            path: "/panels",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$b6b064de078f296 = (e, t)=>()=>({
            path: "/permissions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$18a6ba1ab6e30ce3 = (e, t)=>()=>({
            path: "/permissions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$d94ca23f02b662aa = (e, t)=>()=>({
            path: "/presets",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$b956d067c5bcf6b = (e, t)=>()=>({
            path: "/presets",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$a159e78a5233f6d5 = (e)=>()=>({
            path: "/relations",
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$7e1811c2b24c5dc7 = (e, t)=>()=>({
            path: "/roles",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$9678a115f63a3512 = (e, t)=>()=>({
            path: "/roles",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$db094362415247da = (e, t)=>()=>({
            path: "/shares",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$1df9beb020e7b16b = (e, t)=>()=>({
            path: "/shares",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$f32ebad153facfaa = (e, t)=>()=>({
            path: "/translations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$883995c7fd4b6dba = (e, t)=>()=>({
            path: "/translations",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$1b62b99291caca7c = (e, t)=>()=>({
            path: "/users",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$3493b8991d49f558 = (e, t)=>()=>({
            path: "/users",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$20912a824a8fdfb3 = (e, t)=>()=>({
            path: "/versions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$46a32ae567720acd = (e, t)=>()=>({
            path: "/versions",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$b88c523063979268 = (e, t)=>()=>({
            path: "/webhooks",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        }), $0a1528612dc62d8d$export$c6ed5a0504098e37 = (e, t)=>()=>({
            path: "/webhooks",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "POST"
        });
var $0a1528612dc62d8d$export$2e6e3ad634e3776 = (e)=>()=>({
            path: `/activity/comment/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$3d16e031f6551662 = (e)=>()=>({
            path: `/collections/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$3bdd81914afda1ef = (e)=>{
    let t = (r, s = [])=>{
        if (typeof r == "object") {
            let a = [];
            for(let p in r){
                let i = r[p] ?? [];
                if (Array.isArray(i)) for (let c of i)a.push(t(c, [
                    ...s,
                    p
                ]));
                else if (typeof i == "object") for (let c of Object.keys(i)){
                    let y = i[c];
                    for (let x of y)a.push(t(x, [
                        ...s,
                        `${p}:${c}`
                    ]));
                }
            }
            return a.flatMap((p)=>p);
        }
        return [
            ...s,
            String(r)
        ].join(".");
    };
    return e.flatMap((r)=>t(r));
}, $0a1528612dc62d8d$export$9f72cc599b0bf53 = (e)=>{
    let t = {};
    Array.isArray(e.fields) && e.fields.length > 0 && (t.fields = $0a1528612dc62d8d$export$3bdd81914afda1ef(e.fields).join(",")), e.filter && Object.keys(e.filter).length > 0 && (t.filter = JSON.stringify(e.filter)), e.search && (t.search = e.search), "sort" in e && e.sort && (t.sort = typeof e.sort == "string" ? e.sort : e.sort.join(",")), typeof e.limit == "number" && e.limit >= -1 && (t.limit = String(e.limit)), typeof e.offset == "number" && e.offset >= 0 && (t.offset = String(e.offset)), typeof e.page == "number" && e.page >= 1 && (t.page = String(e.page)), e.deep && Object.keys(e.deep).length > 0 && (t.deep = JSON.stringify(e.deep)), e.alias && Object.keys(e.alias).length > 0 && (t.alias = JSON.stringify(e.alias)), e.aggregate && Object.keys(e.aggregate).length > 0 && (t.aggregate = JSON.stringify(e.aggregate)), e.groupBy && e.groupBy.length > 0 && (t.groupBy = e.groupBy.join(","));
    for (let [r, s] of Object.entries(e))r in t || (typeof s == "string" || typeof s == "number" || typeof s == "boolean" ? t[r] = String(s) : t[r] = JSON.stringify(s));
    return t;
};
var $0a1528612dc62d8d$export$c8ea5e9f84346833 = (e, t)=>{
    if (e.length === 0) throw new Error(t);
};
var $0a1528612dc62d8d$export$325fa311b6904a3e = (e, t)=>{
    if ((0, $dcd4e94b4ab65c1f$export$f4f5d58c6b1bdc44)(String(e))) throw new Error(t);
};
var $0a1528612dc62d8d$export$445e4e54f220f197 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/dashboards",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$794471fec7cce9b7 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/dashboards/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$2bbad96c62fdba3e = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $0a1528612dc62d8d$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/fields/${e}/${t}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$d5d18797070b684f = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/files",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$dccb98b97a3cb8be = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/files/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$ce8eb53a3b42d13f = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/flows",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$cd28db42dd4d115b = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/flows/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$5d771c96f71348b1 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/folders",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$b2b7d6e359abed26 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/folders/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$eb988beca99de9d6 = (e, t)=>()=>{
        let r = {};
        return $0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $0a1528612dc62d8d$export$325fa311b6904a3e(e, "Cannot use deleteItems for core collections"), Array.isArray(t) ? ($0a1528612dc62d8d$export$c8ea5e9f84346833(t, "keysOrQuery cannot be empty"), r = {
            keys: t
        }) : ($0a1528612dc62d8d$export$c8ea5e9f84346833(Object.keys(t), "keysOrQuery cannot be empty"), r = {
            query: t
        }), {
            path: `/items/${e}`,
            body: JSON.stringify(r),
            method: "DELETE"
        };
    }, $0a1528612dc62d8d$export$8d8542dbbc23fe1a = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $0a1528612dc62d8d$export$325fa311b6904a3e(e, "Cannot use deleteItem for core collections"), $0a1528612dc62d8d$export$c8ea5e9f84346833(String(t), "Key cannot be empty"), {
            path: `/items/${e}/${t}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$15471b882705b3b5 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/notifications",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$921a032020d7fa9d = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/notifications/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$b07054d85c60e66d = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/operations",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$b8c2adade071dc6c = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/operations/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$4210f6e285c76393 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/panels",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$deb6901f3e6044a0 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/panels/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$3ee9c75cf06721e7 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/permissions",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$8676cf9296cb5cfa = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/permissions/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$137997f4e1216209 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/presets",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$f6f31fb6da61ffc6 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/presets/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$16e56e18d1cf5c3c = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $0a1528612dc62d8d$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/relations/${e}/${t}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$701d2b595a570390 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/roles",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$a7396bae498de6f1 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/roles/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$64e78a733483102d = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/shares",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$a27010536c35429f = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/shares/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$22362e8004ffb5c2 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/translations",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$9f7b6bc89a79a3e8 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/translations/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$c89e44cbc145e361 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/users",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$7d0f10f273c0438a = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/users/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$b81ddf8da23a0767 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/versions",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$6f86304d8439c37c = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/versions/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$b634378700de9adc = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/webhooks",
            body: JSON.stringify(e),
            method: "DELETE"
        }), $0a1528612dc62d8d$export$273c5791092616a1 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/webhooks/${e}`,
            method: "DELETE"
        });
var $0a1528612dc62d8d$export$6475104154d58eed = (e)=>()=>({
            path: "/activity",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$2920dda248384b69 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/activity/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$258f7bf0e3a9da18 = (e, t)=>()=>{
        let r = String(e);
        return $0a1528612dc62d8d$export$c8ea5e9f84346833(r, "Collection cannot be empty"), {
            path: (0, $dcd4e94b4ab65c1f$export$f4f5d58c6b1bdc44)(r) ? `/${r.substring(9)}` : `/items/${r}`,
            method: "GET",
            params: {
                ...t.query ?? {},
                ...t.groupBy ? {
                    groupBy: t.groupBy
                } : {},
                aggregate: t.aggregate
            }
        };
    };
var $0a1528612dc62d8d$export$f19984c2c49eb871 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/assets/${e}`,
            params: t ?? {},
            method: "GET",
            onResponse: (r)=>r.body
        }), $0a1528612dc62d8d$export$251e0afed2252738 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/assets/${e}`,
            params: t ?? {},
            method: "GET",
            onResponse: (r)=>r.blob()
        }), $0a1528612dc62d8d$export$5dd82d346ce3741c = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/assets/${e}`,
            params: t ?? {},
            method: "GET",
            onResponse: (r)=>r.arrayBuffer()
        });
var $0a1528612dc62d8d$export$db7a999e1995428 = ()=>()=>({
            path: "/collections",
            method: "GET"
        }), $0a1528612dc62d8d$export$e130c7ba0494558f = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Collection cannot be empty"), {
            path: `/collections/${e}`,
            method: "GET"
        });
var $0a1528612dc62d8d$export$2675a27295bd1465 = (e)=>()=>({
            path: "/dashboards",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$cd0238957d0994ef = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/dashboards/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$1d217418e0e17831 = ()=>()=>({
            path: "/extensions/",
            method: "GET"
        });
var $0a1528612dc62d8d$export$5f7d4498f5d85591 = ()=>()=>({
            path: "/fields",
            method: "GET"
        }), $0a1528612dc62d8d$export$e248065a94378cfc = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Collection cannot be empty"), {
            path: `/fields/${e}`,
            method: "GET"
        }), $0a1528612dc62d8d$export$382f22472809782a = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $0a1528612dc62d8d$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/fields/${e}/${t}`,
            method: "GET"
        });
var $0a1528612dc62d8d$export$68814c6bac157c56 = (e)=>()=>({
            path: "/files",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$72c04af63de9061a = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/files/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$99f56cec798c3864 = (e)=>()=>({
            path: "/flows",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$ac312892a8dd4618 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/flows/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$1743e20a066bc8f4 = (e)=>()=>({
            path: "/folders",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$a1bf3619deefbb5f = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/folders/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$dc1ffac156057709 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $0a1528612dc62d8d$export$325fa311b6904a3e(e, "Cannot use readItems for core collections"), {
            path: `/items/${e}`,
            params: t ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$5ccb2a3b476b2cd3 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $0a1528612dc62d8d$export$325fa311b6904a3e(e, "Cannot use readItem for core collections"), $0a1528612dc62d8d$export$c8ea5e9f84346833(String(t), "Key cannot be empty"), {
            path: `/items/${e}/${t}`,
            params: r ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$81100ddd061ed17a = (e)=>()=>({
            path: "/notifications",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$bdda8f9364ec9548 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/notifications/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$936f8732910c544a = (e)=>()=>({
            path: "/operations",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$377a225cfe5ebfeb = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/operations/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$813f0d558145d14d = (e)=>()=>({
            path: "/panels",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$2e10da30e4920419 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/panels/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$721293565320f0e = (e)=>()=>({
            path: "/permissions",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$c809f605aa3f36fc = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/permissions/${e}`,
            params: t ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$876e8a52766492f0 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), {
            path: `/permissions/me/${t ? `${e}/${t}` : `${e}`}`,
            method: "GET"
        });
var $0a1528612dc62d8d$export$2d189bdbe254aac6 = (e)=>()=>({
            path: "/presets",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$874f998aa0fa5091 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/presets/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$8d5961895b8dcfc7 = ()=>()=>({
            path: "/relations",
            method: "GET"
        }), $0a1528612dc62d8d$export$c4fa342b35c497d0 = (e)=>()=>({
            path: `/relations/${e}`,
            method: "GET"
        }), $0a1528612dc62d8d$export$daed7da094b8588e = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $0a1528612dc62d8d$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/relations/${e}/${t}`,
            method: "GET"
        });
var $0a1528612dc62d8d$export$88d629fad7ac0485 = (e)=>()=>({
            path: "/revisions",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$ce478fdb2b09ea35 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/revisions/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$577f2e3cc5fb778d = (e)=>()=>({
            path: "/roles",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$dc29cc801582329f = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/roles/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$9e99187ea2f61e6d = (e)=>()=>({
            path: "/settings",
            params: e ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$9f1feac81b77afb6 = (e)=>()=>({
            path: "/shares",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$c64af3887efacee = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/shares/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$2cefaf6e917f5b26 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $0a1528612dc62d8d$export$325fa311b6904a3e(e, "Cannot use readSingleton for core collections"), {
            path: `/items/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$db2e52950db3187d = (e)=>()=>({
            path: "/translations",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$c7a36405c49d706a = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/translations/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$6bceb4096e4dd906 = (e)=>()=>({
            path: "/users",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$eaefaacc687c1c9a = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/users/${e}`,
            params: t ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$3486c7160223313e = (e)=>()=>({
            path: "/users/me",
            params: e ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$1e3bddd4e9a89ec9 = (e)=>()=>({
            path: "/versions",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$c554451349586164 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/versions/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$d4a4edd8aaeaa4d8 = (e)=>()=>({
            path: "/webhooks",
            params: e ?? {},
            method: "GET"
        }), $0a1528612dc62d8d$export$16c5269970cedd3d = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/webhooks/${e}`,
            params: t ?? {},
            method: "GET"
        });
var $0a1528612dc62d8d$export$3aff0b2867912504 = (e)=>()=>({
            method: "POST",
            path: "/schema/apply",
            body: JSON.stringify(e)
        });
var $0a1528612dc62d8d$export$91cf0c2974056a76 = (e, t = !1)=>()=>({
            method: "POST",
            path: "/schema/diff",
            params: t ? {
                force: t
            } : {},
            body: JSON.stringify(e)
        });
var $0a1528612dc62d8d$export$9b097c2fb1bc498 = ()=>()=>({
            method: "GET",
            path: "/schema/snapshot"
        });
var $0a1528612dc62d8d$export$2f9c2c3afcf9e94d = (e = "item")=>()=>({
            method: "GET",
            path: e === "item" ? "/server/specs/graphql" : "/server/specs/graphql/system"
        });
var $0a1528612dc62d8d$export$55d0404a1e43e217 = ()=>()=>({
            method: "GET",
            path: "/server/health"
        });
var $0a1528612dc62d8d$export$7c757dcc6e8e1fc4 = ()=>()=>({
            method: "GET",
            path: "/server/info"
        });
var $0a1528612dc62d8d$export$f6eb17377015b310 = ()=>()=>({
            method: "GET",
            path: "/server/specs/oas"
        });
var $0a1528612dc62d8d$export$d8d419c14af76fcc = ()=>()=>({
            method: "GET",
            path: "/server/ping"
        });
var $0a1528612dc62d8d$export$5a1cd239009d83a6 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/activity/comment/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$c0683150b517c317 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Collection cannot be empty"), {
            path: `/collections/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$4c2b085fa39ccde6 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/dashboards",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$8a2c60458ca4e242 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/dashboards/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$7c8eb78c790b86b1 = (e, t, r)=>()=>(e !== null && $0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Bundle cannot be an empty string"), $0a1528612dc62d8d$export$c8ea5e9f84346833(t, "Name cannot be empty"), {
            path: e ? `/extensions/${e}/${t}` : `/extensions/${t}`,
            params: {},
            body: JSON.stringify(r),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$792a18290d173848 = (e, t, r, s)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), $0a1528612dc62d8d$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/fields/${e}/${t}`,
            params: s ?? {},
            body: JSON.stringify(r),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$88bd792628f814eb = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/files",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$4730664ce047e3bc = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), t instanceof FormData ? {
            path: `/files/${e}`,
            params: r ?? {},
            body: t,
            method: "PATCH",
            headers: {
                "Content-Type": "multipart/form-data"
            }
        } : {
            path: `/files/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$f3d46153a3c4119e = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/flows",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$f1fc4ca98fea70bb = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/flows/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$11cb17c3bee81c86 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/folders",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$2554d0ab4f8435c7 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/folders/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$c7d78f87941eb2fc = (e, t, r, s)=>()=>{
        let a = {};
        return $0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $0a1528612dc62d8d$export$325fa311b6904a3e(e, "Cannot use updateItems for core collections"), Array.isArray(t) ? ($0a1528612dc62d8d$export$c8ea5e9f84346833(t, "keysOrQuery cannot be empty"), a = {
            keys: t
        }) : ($0a1528612dc62d8d$export$c8ea5e9f84346833(Object.keys(t), "keysOrQuery cannot be empty"), a = {
            query: t
        }), a.data = r, {
            path: `/items/${e}`,
            params: s ?? {},
            body: JSON.stringify(a),
            method: "PATCH"
        };
    }, $0a1528612dc62d8d$export$72b8c6d38aa6195b = (e, t, r, s)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(t), "Key cannot be empty"), $0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $0a1528612dc62d8d$export$325fa311b6904a3e(e, "Cannot use updateItem for core collections"), {
            path: `/items/${e}/${t}`,
            params: s ?? {},
            body: JSON.stringify(r),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$7ef44197c3760235 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/notifications",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$31ce28e5754d2c6a = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/notifications/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$6f9af0e14927ba5a = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/operations",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$325ee5fecc354190 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/operations/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$5839273119d35dea = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/panels",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$48868c133243b4bb = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/panels/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$9b78c18c532ff910 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/permissions",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$fd6f7bcb1f904b27 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/permissions/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$2356f1473e0729ff = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/presets",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$85844243b13ae530 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/presets/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$dc49f0fb1fc1899 = (e, t, r, s)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Collection cannot be empty"), $0a1528612dc62d8d$export$c8ea5e9f84346833(t, "Field cannot be empty"), {
            path: `/relations/${e}/${t}`,
            params: s ?? {},
            body: JSON.stringify(r),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$d87af07da5a07efb = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/roles",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$c37c5570c259cd71 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/roles/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$f558026a994b6051 = (e, t)=>()=>({
            path: "/settings",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$1f8f3b884abf7db0 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/shares",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$18127db3286b73a9 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/shares/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$9c933e1ead9ec945 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Collection cannot be empty"), $0a1528612dc62d8d$export$325fa311b6904a3e(e, "Cannot use updateSingleton for core collections"), {
            path: `/items/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$676ff478edc2cd7f = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/translations",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$252cf2d742c72de9 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/translations/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$5946676442d8ccf7 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/users",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$e3ac7a5d19605772 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/users/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$8ddaddf355aae59c = (e, t)=>()=>({
            path: "/users/me",
            params: t ?? {},
            body: JSON.stringify(e),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$2a47cec55cebf1e4 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/versions",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$e74be6490148ac63 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Key cannot be empty"), {
            path: `/versions/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$880ae857f284902c = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "Keys cannot be empty"), {
            path: "/webhooks",
            params: r ?? {},
            body: JSON.stringify({
                keys: e,
                data: t
            }),
            method: "PATCH"
        }), $0a1528612dc62d8d$export$641059283e9ab515 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(String(e), "Key cannot be empty"), {
            path: `/webhooks/${e}`,
            params: r ?? {},
            body: JSON.stringify(t),
            method: "PATCH"
        });
var $0a1528612dc62d8d$export$d2adf65b87e47523 = ()=>()=>({
            method: "POST",
            path: "/utils/cache/clear"
        });
var $0a1528612dc62d8d$export$b1d7f171ae44db2f = (e, t, r, s)=>()=>({
            method: "POST",
            path: `/utils/export/${e}`,
            body: JSON.stringify({
                format: t,
                query: r,
                file: s
            })
        });
var $0a1528612dc62d8d$export$1bcee6330b05af2a = (e, t, r)=>()=>e === "GET" ? {
            path: `/flows/trigger/${t}`,
            params: r ?? {},
            method: "GET"
        } : {
            path: `/flows/trigger/${t}`,
            body: JSON.stringify(r ?? {}),
            method: "POST"
        };
var $0a1528612dc62d8d$export$daf4c137c5f56404 = (e)=>()=>({
            method: "POST",
            path: "/utils/hash/generate",
            body: JSON.stringify({
                string: e
            })
        }), $0a1528612dc62d8d$export$434ee6408013d7f2 = (e, t)=>()=>({
            method: "POST",
            path: "/utils/hash/verify",
            body: JSON.stringify({
                string: e,
                hash: t
            })
        });
var $0a1528612dc62d8d$export$f4cb417afd8211e5 = (e, t)=>()=>({
            path: `/utils/import/${e}`,
            method: "POST",
            body: t,
            headers: {
                "Content-Type": "multipart/form-data"
            }
        });
var $0a1528612dc62d8d$export$2efa0c312a1e244e = (e, t)=>()=>({
            path: `/operations/trigger/${e}`,
            body: JSON.stringify(t ?? {}),
            method: "POST"
        });
var $0a1528612dc62d8d$export$da7e0b54b743b0a0 = (e, t, r = "cookie")=>()=>({
            path: "/shares/auth",
            method: "POST",
            body: JSON.stringify({
                share: e,
                password: t,
                mode: r
            })
        }), $0a1528612dc62d8d$export$ff17cf2336ca5253 = (e, t)=>()=>({
            path: "/shares/invite",
            method: "POST",
            body: JSON.stringify({
                share: e,
                emails: t
            })
        }), $0a1528612dc62d8d$export$deef9315be003768 = (e)=>()=>({
            path: `/shares/info/${e}`,
            method: "GET"
        });
var $0a1528612dc62d8d$export$28ecda779a9bc995 = (e, t, r)=>()=>({
            method: "POST",
            path: `/utils/sort/${e}`,
            body: JSON.stringify({
                item: t,
                to: r
            })
        });
var $0a1528612dc62d8d$export$f5ec01bd6261fcdd = (e, t, r)=>()=>({
            path: "/users/invite",
            method: "POST",
            body: JSON.stringify({
                email: e,
                role: t,
                ...r ? {
                    invite_url: r
                } : {}
            })
        }), $0a1528612dc62d8d$export$62f88f7ee3ce3263 = (e, t)=>()=>({
            path: "/users/invite/accept",
            method: "POST",
            body: JSON.stringify({
                token: e,
                password: t
            })
        }), $0a1528612dc62d8d$export$16015adca85344a = (e, t, r = {})=>()=>({
            path: "/users/register",
            method: "POST",
            body: JSON.stringify({
                email: e,
                password: t,
                ...r
            })
        }), $0a1528612dc62d8d$export$279c5f32650688e0 = (e)=>()=>({
            path: "/register/verify-email",
            params: {
                token: e
            },
            method: "GET"
        }), $0a1528612dc62d8d$export$775267aca7ccdf99 = (e)=>()=>({
            path: "/users/me/tfa/generate",
            method: "POST",
            body: JSON.stringify({
                password: e
            })
        }), $0a1528612dc62d8d$export$9fe5fe9229d48aa3 = (e, t)=>()=>({
            path: "/users/me/tfa/enable",
            method: "POST",
            body: JSON.stringify({
                secret: e,
                otp: t
            })
        }), $0a1528612dc62d8d$export$5441625492178b0a = (e)=>()=>({
            path: "/users/me/tfa/disable",
            method: "POST",
            body: JSON.stringify({
                otp: e
            })
        });
var $0a1528612dc62d8d$export$96ef93abfeef2ab2 = (e, t)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "ID cannot be empty"), {
            path: `/versions/${e}/save`,
            method: "POST",
            body: JSON.stringify(t)
        }), $0a1528612dc62d8d$export$d84892fd77e1c33 = (e)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "ID cannot be empty"), {
            path: `/versions/${e}/compare`,
            method: "GET"
        }), $0a1528612dc62d8d$export$587acce1566fb354 = (e, t, r)=>()=>($0a1528612dc62d8d$export$c8ea5e9f84346833(e, "ID cannot be empty"), {
            path: `/versions/${e}/promote`,
            method: "POST",
            body: JSON.stringify(r ? {
                mainHash: t,
                fields: r
            } : {
                mainHash: t
            })
        });
var $0a1528612dc62d8d$var$q = {}, $0a1528612dc62d8d$export$c58417706a208278 = (e = {})=>(t)=>{
        let r = {
            ...$0a1528612dc62d8d$var$q,
            ...e
        };
        return {
            async request (s) {
                let a = s();
                if (a.headers || (a.headers = {}), "Content-Type" in a.headers ? a.headers["Content-Type"] === "multipart/form-data" && delete a.headers["Content-Type"] : a.headers["Content-Type"] = "application/json", "getToken" in this) {
                    let y = await this.getToken();
                    y && (a.headers || (a.headers = {}), a.headers.Authorization = `Bearer ${y}`);
                }
                let p = $0a1528612dc62d8d$var$b(t.url, a.path, a.params), i = {
                    method: a.method ?? "GET",
                    headers: a.headers ?? {}
                };
                "credentials" in r && (i.credentials = r.credentials), a.body && (i.body = a.body), a.onRequest && (i = await a.onRequest(i)), r.onRequest && (i = await r.onRequest(i));
                let c = await $0a1528612dc62d8d$var$D(p.toString(), i, t.globals.fetch);
                return "onResponse" in a && (c = await a.onResponse(c, i)), "onResponse" in e && (c = await e.onResponse(c, i)), c;
            }
        };
    };
function $0a1528612dc62d8d$export$69e91e91eb5321f7(e, t) {
    return ()=>{
        let r = e();
        return typeof t == "function" ? r.onRequest = t : r.onRequest = (s)=>({
                ...s,
                ...t
            }), r;
    };
}
function $0a1528612dc62d8d$export$efa806de37a4221d(e) {
    return ()=>{
        let t = e();
        return t.method === "GET" && t.params && (t.method = "SEARCH", t.body = JSON.stringify({
            query: {
                ...t.params,
                fields: $0a1528612dc62d8d$export$3bdd81914afda1ef(t.params.fields ?? [])
            }
        }), delete t.params), t;
    };
}
function $0a1528612dc62d8d$export$f6f0dceccdb6a70d(e, t) {
    return ()=>{
        let r = t();
        return e && (r.headers || (r.headers = {}), r.headers.Authorization = `Bearer ${e}`), r;
    };
}
function $0a1528612dc62d8d$export$490486aaefb17d5b(e) {
    return ()=>e;
}


// |String| Checks if a string is a valid email address.
function $6594117c41353000$var$isValidEmail(email) {
    // Regular expression to validate email addresses
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}
var $6594117c41353000$export$2e2bcd8739ae039 = $6594117c41353000$var$isValidEmail;


// |Array| Make an enum for a given number of arguments. I.e. `makeEmun('open', 'closed')` will return `{ open: 'open', closed: 'closed' }`
function $e4b21debaf256ab0$var$makeEnum() {
    var obj = {};
    Array.prototype.forEach.call(arguments, (v)=>{
        obj[v] = v;
    });
    return obj;
}
var $e4b21debaf256ab0$export$2e2bcd8739ae039 = $e4b21debaf256ab0$var$makeEnum;


// |String| Check if a string ends with a character
// Source: http://stackoverflow.com/a/646643/179015 */
function $8f8b399a67e6d72b$var$endsWith(str, test) {
    return str.slice(-test.length) == test;
}
var $8f8b399a67e6d72b$export$2e2bcd8739ae039 = $8f8b399a67e6d72b$var$endsWith;


// |Array| Shuffles an array. Defaults to returning a new array. But can shuffle in place `shuffle(arr, inPlace=false)`.
// Fisher-Yates shuffle. Source http://stackoverflow.com/questions/962802/is-it-correct-to-use-javascript-array-sort-method-for-shuffling*
function $ab0fe0571579ec9d$var$shuffle(arr, inPlace) {
    var array = inPlace === true ? arr : arr.slice(0);
    var tmp, current, top = array.length;
    if (top) while(--top){
        current = Math.floor(Math.random() * (top + 1));
        tmp = array[current];
        array[current] = array[top];
        array[top] = tmp;
    }
    return array;
}
var $ab0fe0571579ec9d$export$2e2bcd8739ae039 = $ab0fe0571579ec9d$var$shuffle;


// |RxJS:String| A typewriter effect that emits characters to add and remove. 


function $cea8e04dbe575457$export$c28c8388be0ab31a(project, resultSelector) {
    return (0, $390adda5fd19a2d6$export$f6e2535fb5126e54)(resultSelector) ? (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(project, resultSelector, 1) : (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(project, 1);
}






function $7d538d433736789b$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $ce4337d88b881b98$export$ccb33e29d92c9a58;
    } : (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}





function $d2f8eca01cb6c1a6$export$6953b97c7d866605() {
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, (0, $b1207576672ff0a1$export$8793edee2d425525)));
    });
}



function $a78699d26319dd58$export$e0eaf3a86c03b2ad(value) {
    return (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(function() {
        return value;
    });
}




function $a58b19dc01ce0b85$export$286ca829307725c9(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(subscriptionDelay.pipe((0, $7d538d433736789b$export$b7df5d561049483a)(1), (0, $d2f8eca01cb6c1a6$export$6953b97c7d866605)()), source.pipe($a58b19dc01ce0b85$export$286ca829307725c9(delayDurationSelector)));
    };
    return (0, $6d95d0a3c23e5dc7$export$6b9f6c0d32c093f9)(function(value, index) {
        return (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(delayDurationSelector(value, index)).pipe((0, $7d538d433736789b$export$b7df5d561049483a)(1), (0, $a78699d26319dd58$export$e0eaf3a86c03b2ad)(value));
    });
}



function $4477933faa875af1$export$1391212d75b2ee65(due, scheduler) {
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$8d6b71a2b178fc32);
    var duration = (0, $9848eae097ed6239$export$9dc4ecf953986f04)(due, scheduler);
    return (0, $a58b19dc01ce0b85$export$286ca829307725c9)(function() {
        return duration;
    });
}



function $18efc9ac364e445d$export$9f77e0932fb78f72(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Infinity;
    concurrent = (concurrent || 0) < 1 ? Infinity : concurrent;
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        return (0, $03097568c8340eb2$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent, undefined, true, scheduler);
    });
}



function $3f0659d06615d3d8$export$ba255e9e49e00608() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $ba29b8cd54e70848$export$29534b2f653ae592)(args);
    return (0, $afca3285ff834980$export$6788812c4e6611e6)(args, scheduler);
}


// |Array| Returns a iterator to keep cycling through all the elements of an array.
function $db6b1f59f31bed6d$var$cycle(arr) {
    var idx = -1;
    return function() {
        if (++idx >= arr.length) idx = 0;
        return arr[idx];
    };
}
var $db6b1f59f31bed6d$export$2e2bcd8739ae039 = $db6b1f59f31bed6d$var$cycle;


// |Math| Return a random number between two values.
function $fdc83e8c8ea069df$var$randomBetween(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}
var $fdc83e8c8ea069df$export$2e2bcd8739ae039 = $fdc83e8c8ea069df$var$randomBetween;


function $a80cf5dc979e0ed3$var$makeTypewriter({ el: el, addCharacter: addCharacter, removeCharacter: removeCharacter, strings: strings, startWith: startWith = "", loop: loop = true, delayStart: delayStart = 0, onFinishString: onFinishString = ()=>{} }) {
    var stringCount = 0;
    var addCharacter = addCharacter || function(character) {
        // Add character to input placeholder
        if (el.innerText.endsWith("|")) el.innerText = el.innerText.slice(0, -1) + character + "|";
        else el.innerText = el.innerText + character + "|";
        // Return null to skip internal adding of dom node
        return null;
    };
    var removeCharacter = removeCharacter || function({ character: character }) {
        if (el.innerText) {
            if (el.innerText.endsWith("|")) el.innerText = el.innerText.slice(0, -2) + "|";
            else el.innerText = el.innerText.slice(0, -1) + "|";
        }
    };
    // Helper function to cycle through the provided strings
    const stringCycler = (0, $db6b1f59f31bed6d$export$2e2bcd8739ae039)(strings);
    // Function to create the typewriter effect for a given string
    const createTypewriterEffect$ = (currentString, deleteOnly = false)=>{
        // Observable to handle adding characters one by one
        const countUp$ = (0, $afca3285ff834980$export$6788812c4e6611e6)(currentString).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)((char, idx)=>{
            var delayInterval;
            switch(char){
                case " ":
                    delayInterval = (0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(100, 200);
                    break;
                case "\u2026":
                    delayInterval = (0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(300, 400);
                    break;
                default:
                    delayInterval = (0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(40, 70);
            }
            if (idx === 0) delayInterval = 0;
            return (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(char).pipe((0, $4477933faa875af1$export$1391212d75b2ee65)(delayInterval, (0, $9864f9013a045943$export$4dc84b80a0d0c8da)), (0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>addCharacter(char)) // Add character
            );
        }), (0, $992cdff55f780f5c$export$3f23594af5f37336)({
            complete: ()=>{
                onFinishString(++stringCount);
            }
        }));
        // Observable to handle removing characters one by one in reverse order
        const countDown$ = (0, $afca3285ff834980$export$6788812c4e6611e6)(currentString.split("").reverse()).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)((char, idx)=>(0, $3f0659d06615d3d8$export$ba255e9e49e00608)(char).pipe((0, $4477933faa875af1$export$1391212d75b2ee65)((0, $fdc83e8c8ea069df$export$2e2bcd8739ae039)(10, 40), (0, $9864f9013a045943$export$4dc84b80a0d0c8da)), (0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>removeCharacter(char)) // Remove character
            )));
        // Observable for a long pause after typing the string
        const longPause$ = (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null).pipe((0, $4477933faa875af1$export$1391212d75b2ee65)(2000));
        // Observable for a short pause before starting to type the next string
        const shortPause$ = (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null).pipe((0, $4477933faa875af1$export$1391212d75b2ee65)(400));
        if (deleteOnly) // Concatenating the observables to create the full typewriter effect sequence
        return (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(longPause$, countDown$, shortPause$);
        else {
            if (!loop) // This is a hack to allow for 'strings' of one length
            return (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(countUp$);
            else // Concatenating the observables to create the full typewriter effect sequence
            return (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(countUp$, longPause$, countDown$, shortPause$);
        }
    };
    var typewriter$;
    if (loop) typewriter$ = (0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null).pipe((0, $18efc9ac364e445d$export$9f77e0932fb78f72)(()=>{
        const currentString = stringCycler();
        return createTypewriterEffect$(currentString).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)(()=>(0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null)) // Ensures the sequence completes before cycling to the next string
        );
    }, 1) // Controls the concurrency level of the expand operator
    );
    else {
        const currentString = stringCycler();
        typewriter$ = createTypewriterEffect$(currentString).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)(()=>(0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null)) // Ensures the sequence completes before cycling to the next string,
        );
    }
    // If we should startWith a string we need to delete it first
    if (startWith) typewriter$ = (0, $4195388abc69bf39$export$ee1b3e54f0441b22)(createTypewriterEffect$(startWith, true).pipe((0, $cea8e04dbe575457$export$c28c8388be0ab31a)(()=>(0, $3f0659d06615d3d8$export$ba255e9e49e00608)(null)) // Ensures the sequence completes before cycling to the next string
    ), typewriter$);
    // Add the delay
    return typewriter$.pipe((0, $4477933faa875af1$export$1391212d75b2ee65)(delayStart));
}
var $a80cf5dc979e0ed3$export$2e2bcd8739ae039 = $a80cf5dc979e0ed3$var$makeTypewriter;


function $b698f32e15bdf913$var$enquire(el) {
    $b698f32e15bdf913$var$makeForm(el);
    $b698f32e15bdf913$var$makePlaceholderMessageText(el);
}
function $b698f32e15bdf913$var$makeForm(el) {
    const buttonEl = el.querySelector("button");
    const emailEl = el.querySelector(".email");
    const messageEl = el.querySelector(".message");
    const spinnerEl = el.querySelector("loader");
    const buttonLabel = el.querySelector("span.label");
    const formStates = (0, $e4b21debaf256ab0$export$2e2bcd8739ae039)("empty", "hasUserContent", "canSend", "posting");
    const formState$ = new (0, $3edc71cdd358c92e$export$cc3d42e6b2b9cf8b)(formStates.empty);
    const email$ = $b698f32e15bdf913$var$makeInputObservable(emailEl);
    const message$ = $b698f32e15bdf913$var$makeInputObservable(messageEl);
    const buttonClick = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(buttonEl, "click");
    formState$.subscribe((v)=>{
        switch(v){
            case formStates.empty:
                emailEl.disabled = false;
                messageEl.disabled = false;
                buttonEl.disabled = true;
                buttonEl.classList.add("disabled");
                el.classList.remove("has-user-content");
                buttonLabel.innerHTML = "Send";
                break;
            case formStates.hasUserContent:
                emailEl.disabled = false;
                messageEl.disabled = false;
                buttonEl.disabled = true;
                buttonEl.classList.remove("success");
                el.classList.add("has-user-content");
                buttonLabel.innerHTML = "Send";
                break;
            case formStates.canSend:
                buttonEl.classList.remove("success");
                buttonEl.classList.remove("disabled");
                emailEl.disabled = false;
                messageEl.disabled = false;
                buttonEl.disabled = false;
                buttonLabel.innerHTML = "Send";
                break;
            case formStates.posting:
                emailEl.disabled = true;
                messageEl.disabled = true;
                buttonEl.disabled = true;
                buttonLabel.innerHTML = "Sending";
                buttonEl.classList.add("sending");
                break;
            case formStates.success:
                buttonLabel.innerHTML = "\uD83D\uDC4D Sent, thank you. We'll be in touch soon&hellip;";
                buttonEl.classList.remove("sending");
                buttonEl.classList.add("success");
                (0, $9848eae097ed6239$export$9dc4ecf953986f04)(5000).pipe((0, $3cf7bf86af55a3de$export$3dea766d36a8935f)((_)=>formState$.getValue() === formState$.success), (0, $992cdff55f780f5c$export$3f23594af5f37336)((_)=>formState$.next(formStates.canSend))).subscribe();
                break;
            case formStates.errored:
                buttonLabel.innerHTML = "Sorry, something went wrong. Please try again.";
                buttonEl.classList.remove("sending");
                (0, $9848eae097ed6239$export$9dc4ecf953986f04)(5000).pipe((0, $3cf7bf86af55a3de$export$3dea766d36a8935f)((_)=>formState$.getValue() === formState$.errored), (0, $992cdff55f780f5c$export$3f23594af5f37336)((_)=>formState$.next(formStates.canSend))).subscribe();
                break;
        }
    });
    // Submit to server
    const client = (0, $0a1528612dc62d8d$export$63427ba69af216fe)("https://directus.electricglen.com").with((0, $0a1528612dc62d8d$export$c58417706a208278)());
    buttonClick.pipe((0, $3e615a6023dd2365$export$d449030e5c10edf7)(email$, message$), (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)(([click, email, message])=>({
            email: email,
            message: message
        })), (0, $3cf7bf86af55a3de$export$3dea766d36a8935f)(({ message: message, email: email })=>(0, $6594117c41353000$export$2e2bcd8739ae039)(email) && message.length > 0), (0, $992cdff55f780f5c$export$3f23594af5f37336)(()=>{
        formState$.next(formStates.posting);
    }), (0, $183291bad0f15980$export$9f6ea8e48bc26eab)(({ email: email, message: message })=>{
        const request$ = (0, $afca3285ff834980$export$6788812c4e6611e6)(client.request((0, $0a1528612dc62d8d$export$1f768fd5b3313118)("Enquiries", {
            message: message,
            email: email
        })));
        return request$.pipe((0, $1e84b4bbfc1f6906$export$3dede90624df3ba9)((error)=>{
            console.error("Error submitting enquiry", error);
            // Re-enable the inputs in case of an error
            formState$.next(formStates.errored);
            // Return an empty observable to terminate the chain
            return 0, $ce4337d88b881b98$export$ccb33e29d92c9a58;
        }));
    })).subscribe((result)=>{
        console.log("Enquiry submitted successfully", result);
        formState$.next(formStates.success);
    });
    // Update whenever the text changes
    return (0, $4c3b7d6e02634e4a$export$77fa7d86f5204e8a)([
        email$,
        message$
    ]).pipe((0, $992cdff55f780f5c$export$3f23594af5f37336)(([email, message])=>{
        const hasUserContent = email.length > 0 || message.length > 0;
        const formIsValid = (0, $6594117c41353000$export$2e2bcd8739ae039)(email) && message.length > 0;
        if (formIsValid) formState$.next(formStates.canSend);
        else if (hasUserContent) formState$.next(formStates.hasUserContent);
        else formState$.next(formStates.empty);
    })).subscribe(([email, message])=>{});
}
function $b698f32e15bdf913$var$makePlaceholderMessageText(el) {
    // Update the placeholder text
    const messageEl = el.querySelector(".message");
    const messagesEl = el.querySelectorAll(".messages li");
    const messages = Array.prototype.map.call(messagesEl, (v)=>v.innerHTML);
    var addCharacter = function(character) {
        // Add character to input placeholder
        if ((0, $8f8b399a67e6d72b$export$2e2bcd8739ae039)(messageEl.placeholder, "|")) messageEl.placeholder = messageEl.placeholder.slice(0, -1) + character + "|";
        else messageEl.placeholder = messageEl.placeholder + character + "|";
        // Return null to skip internal adding of dom node
        return null;
    };
    var removeCharacter = function({ character: character }) {
        if (messageEl.placeholder) {
            if ((0, $8f8b399a67e6d72b$export$2e2bcd8739ae039)(messageEl.placeholder, "|")) messageEl.placeholder = messageEl.placeholder.slice(0, -2) + "|";
            else messageEl.placeholder = messageEl.placeholder.slice(0, -1) + "|";
        }
    };
    (0, $a80cf5dc979e0ed3$export$2e2bcd8739ae039)({
        addCharacter: addCharacter,
        removeCharacter: removeCharacter,
        strings: (0, $ab0fe0571579ec9d$export$2e2bcd8739ae039)(messages)
    }).subscribe();
}
function $b698f32e15bdf913$var$makeInputObservable(inputElement) {
    return (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(inputElement, "input").pipe((0, $642519524078ad18$export$9007f49c319d1ac7)((0, $9864f9013a045943$export$4dc84b80a0d0c8da)), (0, $a5cbdcd6cbcbc1c4$export$871de8747c9eaa88)((event)=>event.target.value), (0, $7614a06bb9dad2f3$export$a4fe86229b0e9bdd)("") // Emit initial value for combineLatest to work immediately
    );
}
var $b698f32e15bdf913$export$2e2bcd8739ae039 = $b698f32e15bdf913$var$enquire;


// |Client| Create dom elements out of an input object
// The input object is in the format:
//    - `[name:string, props:Object, children, options:Object]`, or
//    - `text:string`
// `children` can be another input object
// Options can be:
//    { onRef:function(el:DOMElement) } // Returns a reference to the dom element that is created
function $a2db19d3caa692e7$var$domRender(inputObject, target) {
    function createElement(obj) {
        if (typeof obj === "string") return document.createTextNode(obj);
        const [name, props, children, options] = obj;
        let el;
        const svgTags = [
            "svg",
            "circle",
            "rect",
            "path",
            "line",
            "polyline",
            "polygon",
            "text",
            "marker",
            "defs",
            "linearGradient",
            "stop"
        ];
        if (svgTags.includes(name)) el = document.createElementNS("http://www.w3.org/2000/svg", name);
        else el = document.createElement(name);
        if (props) {
            for(let key in props)if (props.hasOwnProperty(key)) {
                if (typeof props[key] === "object") {
                    if (typeof el[key] !== "object") el[key] = {};
                    Object.assign(el[key], props[key]);
                } else el.setAttribute(key, props[key]);
            }
        }
        if (children) {
            if (Array.isArray(children)) children.forEach((child)=>{
                el.appendChild(createElement(child));
            });
            else el.appendChild(createElement(children));
        }
        if (options && options.onRef) options.onRef(el);
        return el;
    }
    const element = createElement(inputObject);
    target.appendChild(element);
    return element;
}
var $a2db19d3caa692e7$export$2e2bcd8739ae039 = $a2db19d3caa692e7$var$domRender;







function $a2772f38b84c6d6a$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $88dc0495baf4925f$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $a2772f38b84c6d6a$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $4bd741c10f565752$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $a2772f38b84c6d6a$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $a2772f38b84c6d6a$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $a2772f38b84c6d6a$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $4bd741c10f565752$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $73e1b4b68a4d58ca$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $f5ed4ab2a4d1861b$export$1216008129fb82ed)([], (0, $f5ed4ab2a4d1861b$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}


function $ced6ca9f5d4a0c9c$var$animationFrameObservable() {
    return new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)((subscriber)=>{
        let startTime = performance.now();
        let lastUpdate = startTime;
        function animate() {
            const currentTime = performance.now();
            const deltaTime = currentTime - lastUpdate;
            const time = currentTime - startTime;
            lastUpdate = currentTime;
            subscriber.next([
                deltaTime,
                time
            ]);
            // Continue the animation loop
            requestAnimationFrame(animate);
        }
        // Start the animation loop
        requestAnimationFrame(animate);
        // Teardown logic when the observable is unsubscribed
        return ()=>{
        // No specific teardown needed for requestAnimationFrame
        };
    }).pipe((0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)());
}
var $ced6ca9f5d4a0c9c$export$2e2bcd8739ae039 = $ced6ca9f5d4a0c9c$var$animationFrameObservable;



function $9abf71c0bedac53d$var$arrows(targetEl) {
    const color = "hsl(0, 0%, 80%)";
    const colorLight = "hsl(0, 0%, 90%)";
    const arrowDefinition = [
        "path",
        {
            d: "M1 14V2L7 8L1 14Z"
        }
    ];
    const arrowHeadDefinition = [
        "marker",
        {
            id: "arrowhead",
            markerWidth: 15,
            markerHeight: 15,
            refX: 4,
            refY: 7.5,
            orient: "auto",
            fill: colorLight,
            stroke: colorLight,
            "stroke-linejoin": "round"
        },
        [
            arrowDefinition
        ]
    ];
    const defsDefinition = [
        "defs",
        null,
        [
            arrowHeadDefinition
        ]
    ];
    const svgDefinition = [
        "svg",
        {
            width: "100%",
            height: "100%",
            style: {
                pointerEvents: "none",
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0
            }
        },
        [
            defsDefinition
        ]
    ];
    const svgEl = (0, $a2db19d3caa692e7$export$2e2bcd8739ae039)(svgDefinition, targetEl);
    const updateObserver$ = (0, $ced6ca9f5d4a0c9c$export$2e2bcd8739ae039)();
    return {
        makeArrow: ()=>{
            const pathControls = [
                "M",
                0,
                0,
                "C",
                0,
                0,
                0,
                0,
                0,
                0
            ];
            var props = {
                fill: "none",
                stroke: color,
                "stroke-width": "1",
                "marker-end": "url(#arrowhead)",
                "stroke-dasharray": "2 2"
            };
            var pathEl;
            var needsUpdate = true;
            var updateSubscription = updateObserver$.pipe((0, $3cf7bf86af55a3de$export$3dea766d36a8935f)((_)=>needsUpdate), (0, $992cdff55f780f5c$export$3f23594af5f37336)((_)=>needsUpdate = false)).subscribe((_)=>{
                props.d = pathControls.join(" ");
                if (!pathEl) {
                    // Create the line
                    const pathDefinition = [
                        "path",
                        props
                    ];
                    pathEl = (0, $a2db19d3caa692e7$export$2e2bcd8739ae039)(pathDefinition, svgEl);
                } else Object.keys(props).forEach((key)=>{
                    pathEl.setAttribute(key, props[key]);
                });
            });
            var methods = {
                dispose: ()=>{
                    updateSubscription.unsubscribe();
                    if (pathEl) pathEl.remove();
                },
                from: (x, y, cx, cy)=>{
                    pathControls[1] = x;
                    pathControls[2] = y;
                    pathControls[4] = cx;
                    pathControls[5] = cy;
                    needsUpdate = true;
                    return methods;
                },
                to: (x, y, cx, cy)=>{
                    pathControls[6] = cx;
                    pathControls[7] = cy;
                    pathControls[8] = x;
                    pathControls[9] = y;
                    needsUpdate = true;
                    return methods;
                }
            };
            return methods;
        }
    };
}
var $9abf71c0bedac53d$export$2e2bcd8739ae039 = $9abf71c0bedac53d$var$arrows;


// |RxJS:Dom| Watch when the content of a webpage changes size. For example, when the window is resized or when the content of a page makes it taller. Useful for calling `render` on any views that are bound to webpage positions.



function $a1d5dd94ab71d79a$export$7843a4469d64c07e(dueTime, scheduler) {
    if (scheduler === void 0) scheduler = (0, $194b9793c8de3d4c$export$8d6b71a2b178fc32);
    return (0, $73cdb159b7187545$export$871731df685d7753)(function(source, subscriber) {
        var activeTask = null;
        var lastValue = null;
        var lastTime = null;
        var emit = function() {
            if (activeTask) {
                activeTask.unsubscribe();
                activeTask = null;
                var value = lastValue;
                lastValue = null;
                subscriber.next(value);
            }
        };
        function emitWhenIdle() {
            var targetTime = lastTime + dueTime;
            var now = scheduler.now();
            if (now < targetTime) {
                activeTask = this.schedule(undefined, targetTime - now);
                subscriber.add(activeTask);
                return;
            }
            emit();
        }
        source.subscribe((0, $94684df14c25c18c$export$b9e075132cc6937f)(subscriber, function(value) {
            lastValue = value;
            lastTime = scheduler.now();
            if (!activeTask) {
                activeTask = scheduler.schedule(emitWhenIdle, dueTime);
                subscriber.add(activeTask);
            }
        }, function() {
            emit();
            subscriber.complete();
        }, undefined, function() {
            lastValue = activeTask = null;
        }));
    });
}


function $987e5ce25fa759ec$var$pageSizeObservable() {
    // Observable for window resize events
    const resizeObservable = (0, $0f54b2b6fdc78d47$export$a36e16046ae8f1bb)(window, "resize");
    // Observable for content resize using ResizeObserver
    const contentResizeObservable = new (0, $2291f71a0036fa02$export$77cea355fa80b5f4)((subscriber)=>{
        const resizeObserver = new ResizeObserver((entries)=>{
            subscriber.next(entries);
        });
        resizeObserver.observe(document.body);
        // Cleanup function
        return ()=>resizeObserver.disconnect();
    });
    // Merge the two observables and debounce to avoid excessive calls
    const combinedObservable = (0, $2e63864986133df2$export$4950aa0f605343fb)(resizeObservable, contentResizeObservable).pipe((0, $a1d5dd94ab71d79a$export$7843a4469d64c07e)(16, (0, $9864f9013a045943$export$4dc84b80a0d0c8da)), (0, $a2772f38b84c6d6a$export$ed80d9de1d9df928)());
    return combinedObservable;
}
var $987e5ce25fa759ec$export$2e2bcd8739ae039 = $987e5ce25fa759ec$var$pageSizeObservable;


// |DOM| Get a page position for a pixel offset within a DOMElement accounting for 2D css transformations (and 3D transformations with the exception of perspective that needs more work). Origin of `-1,-1` would be left top, `0,0` is the center of the element.
function $bd77175d445eb58c$var$getPointInElementPosition(el, offset = new DOMPoint(0, 0), origin = new DOMPoint(0, 0)) {
    // Get info about element and the window
    const computedStyle = window.getComputedStyle(el);
    const boundingClientRect = el.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    offset = DOMPoint.fromPoint(offset);
    // Update the offset to contain also the position on the page
    offset.x += el.offsetWidth / 2 * origin.x;
    offset.y += el.offsetHeight / 2 * origin.y;
    const matrixValues = $bd77175d445eb58c$var$extractMatrixNumbers(computedStyle.transform);
    if (matrixValues) {
        const domMatrix = new DOMMatrix(matrixValues);
        offset = domMatrix.transformPoint(offset);
        offset.x -= matrixValues[4];
        offset.y -= matrixValues[5];
    }
    const centerX = boundingClientRect.left + boundingClientRect.width / 2;
    const centerY = boundingClientRect.top + boundingClientRect.height / 2;
    const centerPoint = new DOMPoint(centerX + scrollLeft, centerY + scrollTop);
    matrixValues;
    offset.x += centerPoint.x;
    offset.y += centerPoint.y;
    return offset;
}
function $bd77175d445eb58c$var$extractMatrixNumbers(transform) {
    const regex = /matrix(?:3d)?\(([^)]+)\)/;
    const matches = transform.match(regex);
    if (matches) return matches[1].split(",").map(parseFloat);
    else // No transformation matrix found
    return null;
}
var $bd77175d445eb58c$export$2e2bcd8739ae039 = $bd77175d445eb58c$var$getPointInElementPosition;


document.addEventListener("DOMContentLoaded", ()=>{
    var shooglerHtmlCollection = document.getElementsByTagName("a");
    Array.prototype.forEach.call(shooglerHtmlCollection, (0, $b84c8059b1c60c68$export$2e2bcd8739ae039));
    const enquireHeaderEl = document.querySelector("#enquire .enquire-text h2 span");
    const enquireFormEl = document.getElementById("enquire-form");
    (0, $b698f32e15bdf913$export$2e2bcd8739ae039)(enquireFormEl);
    var arrowProvider = (0, $9abf71c0bedac53d$export$2e2bcd8739ae039)(document.querySelector("#background"));
    var arrow = arrowProvider.makeArrow();
    const renderArrow = ()=>{
        const headerOffset = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(enquireHeaderEl, new DOMPoint(6, 4), new DOMPoint(1, 0));
        const headerOffsetControl = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(enquireHeaderEl, new DOMPoint(230, 4), new DOMPoint(1, 0));
        arrow.from(headerOffset.x, headerOffset.y, headerOffsetControl.x, headerOffsetControl.y);
        const originOffset = document.documentElement.scrollWidth < 768 ? 0.9 : 0;
        const formOffset = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(enquireFormEl, new DOMPoint(0, -12), new DOMPoint(originOffset, -1));
        const formOffsetControl = (0, $bd77175d445eb58c$export$2e2bcd8739ae039)(enquireFormEl, new DOMPoint(0, -120), new DOMPoint(originOffset, -1));
        arrow.to(formOffset.x, formOffset.y, formOffsetControl.x, formOffsetControl.y);
    };
    renderArrow();
    (0, $987e5ce25fa759ec$export$2e2bcd8739ae039)().subscribe(renderArrow);
});


//# sourceMappingURL=index.eb9d8b23.js.map
